import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
import { jsPDF as JsPDF } from 'jspdf';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import * as API from "../../utils/apiPath";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';

import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';

import * as leadActions from "../../actions/leadActions";
import DisbursementMemoPage from './DisbursementMemoPage';
// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------


const DeliveryOrder = (props) => {
    const { leadId, id } = useParams();
    const location = useLocation();
    const { actions, usersData, fetchLeadIdDocument, allLeadDocumentByLeadData, userRoleType, isActive,leadInfo,backToLeadHandler,enableCamDetailsHandler,selectionVersioningID } = props;
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    const navigate = useNavigate();

    const [allUsers, setAllUsers] = useState([]);
    const [selectedDocumentFiles, setSelectedDocumentFiles] = useState([]);
    const [getLeadId, setLeadId] = useState('');
    const [allUploadLeadDocument, setAllUploadLeadDocument] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const formRef = useRef(null);
    const [propLeadId, setPropLeadId] = useState('');
    const [allDocumentTypeData, setAllDocumentTypeData] = useState([]);
    const [open, setOpen] = useState(false);
    const [viewModalInfo, setViewModalInfo] = useState([]);
    const [isVerifyDocChecked, setIsVerifyDocChecked] = useState(false);

    const [activeAllSancationDocs, setActiveAllSancationDocs] = useState([]);
    const [digioEsignDetails, setDigioEsignDetails] = useState([]);
    const [allLeadCheckLists, setAllLeadCheckLists] = useState([]);
    const [activeAccordionSections, setActiveAccordionSections] = useState([]);

      const [anchorCategories, setAnchorCategories] = useState([]); 
      const [allDealers, setAllDealers] = useState([]); 
      const [speciallyAbledArr, setSpeciallyAbledArr] = useState([]);
      const [residenceTypesArr, setResidenceTypesArr] = useState([]);
      const [bankingUpiArr, setBankingUpiArr] = useState([]);
      const [constitutionArr, setConstitutionArr] = useState([]);
      const [customerTypeArr, setCustomerTypeArr] = useState([]);
      const [vehicleMakerArr, setVehicleMakerArr] = useState([]);
      const [vehicleUseArr, setVehicleUseArr] = useState([]);
      const [insuranceArr, setInsuranceArr] = useState([]);
      const [vehicleModelsArr, setVehicleModelsArr] = useState([]);
      const [businessValidationProofArr, setBusinessValidationProofArr] = useState([]);
      const [turnoverIncomeArr, setTurnoverIncomeArr] = useState([]);
      const [workingCapitalCycleArr, setWorkingCapitalCycleArr] = useState([]);
      const [addedLeadCoapplicantGuarantorRows, setAddedLeadCoapplicantGuarantorRows] = useState([]);
      const [coapplicantGuarantorRows, setCoapplicantGuarantorRows] = useState([]);
      const [accountTypeArr, setAccountTypeArr] = useState([]);
      const [crifDetails, setCrifDetails] = useState([]);  
      const [bankDetails, setBankDetails] = useState([]); 
      const [camApprovalHistory, setCamApprovalHistory] = useState([]); 
      
        const [cAMMarginMoney, setCAMMarginMoney] = useState(0);
        const [annualIrr, setAnnualIrr] = useState(null);
        const [error, setError] = useState(null);
        const [showSanctionNote, setShowSanctionNote] = useState('');
        const [sanctionApproveLatestStatus, setSanctionApproveLatestStatus] = useState(0);
        const [sanctionApproveAndSendMailLatestStatus, setSanctionApproveAndSendMailLatestStatus] = useState(0);
        const [approveBtnAction, setApproveBtnAction] = useState(0);
        const [uploadBtnAction, setUploadBtnAction] = useState(0);
        const [sendEmailBtnAction, setSendEmailBtnAction] = useState(0);
        const [openUploadDoc, setOpenUploadDoc] = useState(false);
        const [openRejectAmt, setOpenRejectAmt] = useState(false); 
        const [proposedRejectAmt, setproposedRejectAmt] = useState('');
        const [noOfAssetsToBeFinancedAfter, setNoOfAssetsToBeFinancedAfter] = useState('');
        const [multiofTotalAssetsNoofAssets, SetMultiofTotalAssetsNoofAssets] = useState('');
    
    const [isFIOpen, setIsFIOpen] = useState(false);
    const [isSanctionLetterPendingItemsOpen, setIsSanctionLetterPendingItemsOpen] = useState(false);
    const [isSignatureOpen, setIsSignatureOpen] = useState(false);
    const [isAgreementOpen, setIsAgreementOpen] = useState(false);
    const [isGuarantorOpen, setIsGuarantorOpen] = useState(false);
    const [isRepaymentDetailsOpen, setIsRepaymentDetailsOpen] = useState(false);
    const [isInsuranceDetailsOpen, setIsInsuranceDetailsOpen] = useState(false);
    const [isMSMECertificateOpen, setIsMSMECertificateOpen] = useState(false);

    
    
    const [sanctionFormStatus, setSanctionFormStatus] = useState(false);
    const [enableUpdatePdfDetails, setEnableUpdatePdfDetails] = useState(false);
    const [refNo, setRefNo] = useState('');
    const [refDoNo, setRefDoNo] = useState('');
    const [dealerName, setDealerName] = useState('');
    const [dealerBenificaryName, setDealerBenificaryName] = useState('');
    const [dearlerSubventionDedcuteAmount, setDearlerSubventionDedcuteAmount] = useState('');
    const [doDate, setDoDate] = useState('');
    const [dealerAddress, setDealerAddress] = useState('');

    const [dealerBankName, setDealerBankName] = useState('');
    const [dealerAccountNo, setDealerAccountNo] = useState('');
    const [dealerIfsc, setDealerIfsc] = useState('');

    const [insuranceFor, setInsuranceFor] = useState('For insurance by ckers');
    const [dealerSubvention, setDealerSubvention] = useState('Dealer Subvention');

    const [insuranceForValue, setInsuranceForValue] = useState('');
    const [dealerSubventionValue, setDealerSubventionValue] = useState('');  

    const [loanAmountValue, setLoanAmountValue] = useState('');
    const [processingFeeOnFinanceAmountPlusGSTValue, setProcessingFeeOnFinanceAmountPlusGSTValue] = useState('');
    const [lessProcessingFeeIncludingGSTValue, setLessProcessingFeeIncludingGSTValue] = useState('');
    const [lessInsuranceByKotakMahindraValue, setLessInsuranceByKotakMahindraValue] = useState('');

    const [lessPreEmiTill5THJanValue, setLessPreEmiTill5THJanValue] = useState('');
    const [fileChargeValue, setFileChargeValue] = useState(''); 

    const [netDisbursementValue, setNetDisbursementValue] = useState('');
    const [nameOfSupplierDealerValue, setNameOfSupplierDealerValue] = useState(''); 

    const [exShowroomPriceValue, setExShowroomPriceValue] = useState('');
    const [insuranceAmounByDealerValue, setInsuranceAmounByDealerValue] = useState(''); 
    const [totalOnRoadPriceValue, setTotalOnRoadPriceValue] = useState(''); 
    const [assetValueVehicleVehcilesValue, setAssetValueVehicleVehcilesValue] = useState('');
    const [noOfAssetValue, setNoOfAssetValue] = useState('');
    const [totalDownPaymentByCustomerValue, setTotalDownPaymentByCustomerValue] = useState('');
    const [isReadyToModify, setIsReadyToModify] = useState(true);
 
    const [subjectivityDoDetails, setSubjectivityDoDetails] = useState(`Payment will be release with in 2-3 days on receipt of the following documents. Please send the following Documents with our hypothecation endorsement to our office immediately on delivery of vehicle.<br />1. Original Invoice Chassis and Body.<br />2. Photocopy of RC Book.<br />3. Copy of Comprehensive Insurance Policy with IDV coverage of 95% of Chassis and Body with 0% depreciation and cKers HP.<br />4. Photo of Delivery of the vehicle with customer and Dealer Staff or cKers Finance staff to be share.`);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [leadCity, setLeadCity] = useState('');
    const [leadName, setLeadName] = useState('');
    const [leadAddress, setLeadAddress] = useState('');
    const [camDetails, setCamDetails] = useState([]);
    const [savedSanctionDetailsInfo, setSavedSanctionDetailsInfo] = useState([]); 
    const [lessPreEmiTill5thLabel, setLessPreEmiTill5thLabel] = useState('Less: Pre-EMI Till 5TH');

    const [enachItem, setEnachItem] = useState([]);
    const [openAmt, setOpenAmt] = useState(false);
    const [preloaderStatus, setPreloaderStatus] = useState(false);

    const docViewUrl = `${config.API_BASE_URL}uploads/finbox_bank_statements/`;
    const [viewUPIModulePermissionStatus, setViewUPIModulePermissionStatus] = useState(false);
    const [isCamChecked, setIsCamChecked] = useState(false);
    const [showLeadDetails, setShowLeadDetails] = useState(false);
    const [allLeads, setAllLeads] = useState([]);
    const [proposedAmt, setProposedAmt] = useState('');
    const [proposedDebitDate, setProposedDebitDate] = useState('');
    const [amountOfProcessingFee, setAmountOfProcessingFee] = useState(0);
    const [totalMarginMoneyReceiptAmt, setTotalMarginMoneyReceiptAmt] = useState(0);
    const [netDisbursementAmt, setNetDisbursementAmt] = useState(0);
    const [lessProcessingFeeExcludingGST, setLessProcessingFeeExcludingGST] = useState(0);

    const [feeChargesPayable, setFeeChargesPayable] = useState(0);

    const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
    const [viewAllDetailsOpen, setViewAllDetailsOpen] = useState(false);
    const [viewDetailsModalInfo, setViewDetailsModalInfo] = useState([]);
    const [insuranceByCKersAmt, setInsuranceByCKersAmt] = useState(0);
  

    const roundNumber = (num) => {
        if (!num && num !== 0) return 0; 
        return Math.round(num);
      };
    function calculateValue(value,percentage) {
        const roundedUp = Math.ceil(value * percentage); // ROUNDUP equivalent
    
        const output = roundNumber((roundedUp / 100) * 1.18);
        return output; 
      }

    useEffect(() => {
     
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        if (authToken === null) {
            navigate('/login');
        }

        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        actions.usersData(requestData);
        if (usersData.success) {
            setAllUsers(usersData.data);
        }

        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const dd = String(today.getDate()).padStart(2, '0');

        const formattedDate = `${yyyy}-${mm}-${dd}`;
        setDoDate(formattedDate);
    }, [setDoDate]);

    const formattedDate = currentDate.toLocaleDateString('en-IN', {
         year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      });

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const formatDateForValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }
    
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');
    
        return `${day}-${month}-${year}`;
    };


    const clickCcmTab = () => {      
        backToLeadHandler('cam');
        enableCamDetailsHandler(true); 
        const timer = setTimeout(() => {
            const divElement = document.getElementById("pills-disbursement_memo-tab");
            if (divElement) {
              divElement.click(); 
            }
          }, 2000);       
          return () => clearTimeout(timer); 
      };

      useEffect(() => { 
        if (leadInfo?.data?.length > 0) {

            const name = leadInfo.data[0]?.name;
            setLeadName(name);

            const city = leadInfo.data[0]?.city;
            setLeadCity(city);

            const fullAddress = leadInfo.data[0]?.full_address;
            setLeadAddress(fullAddress); 
           // console.log("lead info - ", leadInfo?.data);
            setDealerName(leadInfo.data[0]?.dealer_name);
              
        } 
        
      }, [leadInfo]); 


    const getSanctionConfigData = async (action='',notes='') => {

        let actionStatus = '0';
        let submitStatus =  true;
         
        if(action ==='approve'){
            actionStatus = '1';
            if(notes ===''){
                toast.error("Notes is required.", {
                    position: "top-right",
                });
                submitStatus =  false;
            }
        }else if(action ==='reject'){
            actionStatus = '2';
    
              if(notes ===''){
                  toast.error("Notes is required.", {
                      position: "top-right",
                  });
                  submitStatus =  false;
              }
            }else if(action ==='reversal'){
                actionStatus = '3';
        
                  if(notes ===''){
                      toast.error("Notes is required.", {
                          position: "top-right",
                      });
                      submitStatus =  false;
                  }      

            } 
            
            if(submitStatus){
            if (id !== undefined) {
            setPropLeadId(atob(id));
            setLeadId(propLeadId);
            let readyToSubmit = true;

            const additionalDetails = {"exShowroomPriceValue" : exShowroomPriceValue, 'insuranceAmounByDealerValue' : insuranceAmounByDealerValue, "totalOnRoadPriceValue" : totalOnRoadPriceValue,"loanAmountValue" : loanAmountValue, "processingFeeOnFinanceAmountPlusGSTValue" : processingFeeOnFinanceAmountPlusGSTValue,"lessProcessingFeeIncludingGSTValue":lessProcessingFeeIncludingGSTValue,"lessInsuranceByKotakMahindraValue" : lessInsuranceByKotakMahindraValue, "lessPreEmiTill5THJanValue" : lessPreEmiTill5THJanValue,"fileChargeValue" :fileChargeValue, "netDisbursementValue" : netDisbursementValue,"nameOfSupplierDealerValue" : nameOfSupplierDealerValue, "insuranceFor" : insuranceFor,"dealerSubvention" : dealerSubvention,"insuranceForValue" :insuranceForValue,"dealerSubventionValue" :dealerSubventionValue,"assetValueVehicleVehcilesValue" : assetValueVehicleVehcilesValue, "noOfAssetValue":noOfAssetValue, "totalDownPaymentByCustomerValue" : totalDownPaymentByCustomerValue} 

            const additionalDODetails = {"refDoNo" : refDoNo,"dealerName" : dealerName, "dealerAddress":dealerAddress,"dealerBankName":dealerBankName,"dealerAccountNo" : dealerAccountNo,"dealerIfsc" : dealerIfsc,"dearlerSubventionDedcuteAmount" :dearlerSubventionDedcuteAmount ,"doDate" :doDate,"dealerBenificaryName" :dealerBenificaryName,"netDisbursementAmt" :netDisbursementAmt} 
 
            let obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id),"action_status":actionStatus,'notes' :notes,"sendEmail" : sendEmailBtnAction,"additionalDetails":additionalDetails ,"additionalDODetails":additionalDODetails, 'api_calling_module' : "delivery_order", version_id : selectionVersioningID , 'userRoleType' : userRoleType};
            if(enableUpdatePdfDetails){
                
                if(refDoNo === ''){
                    toast.error("Reference No is required.", {
                        position: "top-right",
                    });
                    readyToSubmit = false;
                } else if( dealerName === '' ){
                    toast.error("Please select dealer.", {
                        position: "top-right",
                    });
                    readyToSubmit = false;    

                } else if( subjectivityDoDetails === '' ){
                    toast.error("Source dealer details is required.", {
                        position: "top-right",
                    });
                    readyToSubmit = false;
                }   
                
                obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id),'subjectivityDoDetails' : subjectivityDoDetails, "refNo" : refNo , "enableUpdatePdfDetails" : enableUpdatePdfDetails ,"action_status":actionStatus,'notes' :notes,"sendEmail" : sendEmailBtnAction,"additionalDetails":additionalDetails,"additionalDODetails":additionalDODetails, 'api_calling_module' : "delivery_order", version_id : selectionVersioningID, 'userRoleType' : userRoleType}; 
            } 

            if(readyToSubmit) {
                // console.log("obj lead id- ", obj);
                const requestData = encryptData(obj);
                const response = actions.getSanctionConfigData(requestData);

                response.then((result) => {
                    setOpenUploadDoc(false);
                    setUploadBtnAction(0);
                    setSendEmailBtnAction(0);
                    setOpenRejectAmt(false);
                    // console.log("Promise resolved -  source data:", result); 
                    if (result.data.success === 1) {
                        
                        const resultArr = result.data.data;

                        const allDealersMasters = resultArr?.all_dealers || [];
                        setAllDealers(allDealersMasters);
                        
                        if(dealerName !== ''){ 
                            const dealerInfo = allDealersMasters.find(doc => doc.name === dealerName);
                            // setRefDoNo(event.target.value);
                            setDealerAddress(dealerInfo?.address);
                            setDealerBankName(dealerInfo?.bank_name);
                            setDealerAccountNo(dealerInfo?.account_no);
                            setDealerIfsc(dealerInfo?.ifsc);
                            setDealerBenificaryName(dealerInfo?.benificary_name); 
                         }
                        
                        const uniqueDocSections = [...new Set(resultArr.activeAllSancationDocs.map(doc => doc.doc_section))];

                        console.log(" ---- setActiveAccordionSections", uniqueDocSections);

                        setActiveAccordionSections(uniqueDocSections);

                        setActiveAllSancationDocs(resultArr?.activeAllSancationDocs);
                        setDigioEsignDetails(resultArr?.digioEsignDetails?.[0]);
                         
                        // get lead assigned checklists
                        const checkListsResults = resultArr?.all_checklists;
                        const checkListsResultsArr = Object.keys(checkListsResults).map(
                            (key) => checkListsResults[key]
                        );
                        
                        setAllLeadCheckLists(checkListsResultsArr);
                        // alert('here');
                        const sanctionDetailsInfo = resultArr?.sanction_details_info || {};

                        const additionalDODetailsParsed =
                        sanctionDetailsInfo?.additionalDODetails &&
                        sanctionDetailsInfo.additionalDODetails !== ''
                            ? JSON.parse(sanctionDetailsInfo.additionalDODetails)
                            : [];
                        
                         console.log("sanctionDetailsInfo = ",sanctionDetailsInfo);
                       
                        setSavedSanctionDetailsInfo(sanctionDetailsInfo);
                        if(sanctionDetailsInfo !== null ){
                          
                           
                        if(sanctionDetailsInfo?.additionalDetails){
                            const parsedData = JSON.parse(sanctionDetailsInfo?.additionalDetails);

                            const parsedDOData = JSON.parse(sanctionDetailsInfo?.additionalDODetails);

                           setRefDoNo(parsedDOData?.refDoNo); 
                           setDealerName(parsedDOData?.dealerName); 
                           setDealerAddress(parsedDOData?.dealerAddress); 
                           setDealerBankName(parsedDOData?.dealerBankName);
                           setDealerAccountNo(parsedDOData?.dealerAccountNo);
                           setDealerIfsc(parsedDOData?.dealerIfsc);
                           setDearlerSubventionDedcuteAmount(parsedDOData?.dearlerSubventionDedcuteAmount); 

                           if(parsedDOData?.doDate !=='' && parsedDOData?.doDate !== undefined){
                            setDoDate(parsedDOData?.doDate); 
                           } 
                            
                            if(parsedData?.exShowroomPriceValue !== '' && parsedData?.exShowroomPriceValue !== undefined) {
                                if(parsedData?.insuranceFor !== '') {
                                    setInsuranceFor(parsedData?.insuranceFor);
                                }
                                if(parsedData?.dealerSubvention !== '') {
                                    setDealerSubvention(parsedData?.dealerSubvention);
                                }

                                setExShowroomPriceValue(parsedData?.exShowroomPriceValue);
                                setInsuranceAmounByDealerValue(parsedData?.insuranceAmounByDealerValue);  
                                setTotalOnRoadPriceValue(parsedData?.totalOnRoadPriceValue);
                                
                                setLoanAmountValue(parsedData?.loanAmountValue); 
                                setProcessingFeeOnFinanceAmountPlusGSTValue(parsedData?.processingFeeOnFinanceAmountPlusGSTValue);
                                setLessProcessingFeeIncludingGSTValue(parsedData?.lessProcessingFeeIncludingGSTValue);
                                setLessInsuranceByKotakMahindraValue(parsedData?.lessInsuranceByKotakMahindraValue);
                                setLessPreEmiTill5THJanValue(parsedData?.lessPreEmiTill5THJanValue);
                                setFileChargeValue(parsedData?.fileChargeValue);
                                setNetDisbursementValue(parsedData?.netDisbursementValue);
                                setNameOfSupplierDealerValue(parsedData?.nameOfSupplierDealerValue);

                                setInsuranceForValue(parsedData?.insuranceForValue);
                                setDealerSubventionValue(parsedData?.dealerSubventionValue);

                                setAssetValueVehicleVehcilesValue(parsedData?.assetValueVehicleVehcilesValue);
                                setNoOfAssetValue(parsedData?.noOfAssetValue);
                                setTotalDownPaymentByCustomerValue(parsedData?.totalDownPaymentByCustomerValue);
 
                        }
                                
                        }    
                           
                        if(sanctionDetailsInfo?.refNo){
                            setRefNo(sanctionDetailsInfo.refNo);
                        }
                        if(sanctionDetailsInfo?.subjectivityDoDetails){
                            setSubjectivityDoDetails(sanctionDetailsInfo.subjectivityDoDetails);                            
                        }

                        if (additionalDODetailsParsed.refDoNo !== '' ) {
                            setSanctionApproveAndSendMailLatestStatus(sanctionDetailsInfo?.send_mail_status_do);                            
                            setSanctionApproveLatestStatus(sanctionDetailsInfo?.action_status_do);
                            if(sanctionDetailsInfo?.action_status_do < 1){
                             const showResNote = `Sent to Credit Operation On ${sanctionDetailsInfo.created_at_do} by ${sanctionDetailsInfo.createdByNameDO}`;
                             setShowSanctionNote(showResNote);
                           }
                  
                           if (sanctionDetailsInfo?.action_status_do === '1') {
                            
                            
                            let showResNote = `Delivery Order Approved By Credit Operation On ${sanctionDetailsInfo?.created_at_do} by ${sanctionDetailsInfo.createdByNameDO}`;

                            if (sanctionDetailsInfo?.send_mail_status_do === '1') {
                                showResNote = `The Delivery Order has been approved, and the email was sent successfully On ${sanctionDetailsInfo?.created_at_do} by ${sanctionDetailsInfo.createdByNameDO}`;
                            }

                            
                             setShowSanctionNote(showResNote);
                         }
                 
                           if(sanctionDetailsInfo?.action_status_do === '2'){
                             const showResNote = `Delivery Order Rejected By Credit Operation On ${sanctionDetailsInfo.created_at_do} by ${sanctionDetailsInfo.createdByNameDO},  Comment : ${sanctionDetailsInfo.notes_do} by ${sanctionDetailsInfo.createdByNameDO}`;
                             setShowSanctionNote(showResNote);
                           }

                           if(sanctionDetailsInfo?.action_status_do === '3'){
                            const showResNote = `Reversal request sent By Credit On ${sanctionDetailsInfo.created_at_do} by ${sanctionDetailsInfo.createdByNameDO},  Comment : ${sanctionDetailsInfo.notes_do} by ${sanctionDetailsInfo.createdByNameDO}`;
                            setShowSanctionNote(showResNote);
                          } 
                          
                         }
                        } 
 
                    }else{ 
                        toast.error(result.data.message, {
                            position: "top-right",
                        });
                    }
 
                    if(enableUpdatePdfDetails){
                        setEnableUpdatePdfDetails(false); 
                    }

                    
                    getCAMDetailsData();
                }).catch((error) => {
                    //  console.error("Promise rejected -  source data :", error); 
                });
            }
        }
    }
     
    };

    const getCAMDetailsData = async () => {
        if (!id) {
          console.error("Error: ID is undefined.");
          return;
        }
      
        try {
          const decodedId = atob(id);
           
          const obj = {
            start: '0',
            length: config.MAX_RECORDS,
            lead_id: decodedId,
            with_additional_info:'yes',
            api_calling_module : "delivery_order",
            version_id : selectionVersioningID
          };
       
          setCoapplicantGuarantorRows(addedLeadCoapplicantGuarantorRows);
          const requestData = encryptData(obj);
          const result = await actions.getCAMDetails(requestData);
      
          if (result?.data?.success === 1) {
            const results = result.data.data?.data || {};
            const resultArr = Object.values(results);
            
            if (resultArr?.length > 0 && resultArr[0]?.cam_details) {
                const camDetails = resultArr[0].cam_details; 
                const jsonData = JSON.parse(camDetails);  
                
                if (jsonData?.dob === '0000-00-00') {
                  jsonData.dob = '';
                }

                
                setCamDetails(jsonData); 

                 let totalDownPaymentByCustomer = 0; 
                 if(jsonData?.dmemo_total_down_payment_by_customer !== ''){
                   totalDownPaymentByCustomer = jsonData?.dmemo_total_down_payment_by_customer || 0; 
                  }  
                     

                let insuranceByCfplAmount = 0;
                
                 if(jsonData?.dmemo_insurance_by_cfpl !== ''){
                   insuranceByCfplAmount = jsonData?.dmemo_insurance_by_cfpl; 
                  }  
                  setInsuranceByCKersAmt(insuranceByCfplAmount); 

                let gstAmount = 0;
                 if(jsonData?.dmemo_processing_fee_including_gst !== ''){
                   gstAmount = (jsonData?.dmemo_processing_fee_including_gst * 18) / 100; 
                  }

               // setAmountOfProcessingFee(roundNumber(gstAmount));
                
                setRefNo(jsonData?.dmemo_reference_no);
                if (jsonData?.coapplicantGuarantorDetails) {
                 setCoapplicantGuarantorRows(jsonData.coapplicantGuarantorDetails);
                 // setAddedLeadCoapplicantGuarantorRows
                  
                } 

                console.log("savedSanctionDetailsInfo = ", savedSanctionDetailsInfo); 
                 if(savedSanctionDetailsInfo?.id === undefined) { 
                    // for null
                    setExShowroomPriceValue(jsonData?.dmemo_invoice_price_per_vehicle);
                    setInsuranceAmounByDealerValue(jsonData?.assets_insurance_by_dealer);  
                    setTotalOnRoadPriceValue(jsonData?.dmemo_total_cost_per_vehicle);
                    
                    setLoanAmountValue(jsonData?.dmemo_funding_per_vehicle); 
                    setProcessingFeeOnFinanceAmountPlusGSTValue(jsonData?.dmemo_processing_fee_on_finance_amount_plus_gst);
                    setLessProcessingFeeIncludingGSTValue(jsonData?.dmemo_processing_fee_including_gst);
                    setLessInsuranceByKotakMahindraValue(jsonData?.cam_kotak_li_amount);
                    setLessPreEmiTill5THJanValue(jsonData?.dmemo_less_pre_emi_till_5th_jan);
                    setFileChargeValue(jsonData?.cam_file_charges);
                    setNetDisbursementValue(jsonData?.dmemo_net_disbursement);
                    setNameOfSupplierDealerValue(jsonData?.cam_dealer_name);

                    setAssetValueVehicleVehcilesValue(jsonData?.dmemo_invoice_price_all_vehicle);
                    setNoOfAssetValue(jsonData?.dmemo_no_of_asset);

                    setTotalDownPaymentByCustomerValue(jsonData?.dmemo_total_down_payment_by_customer);
 
                    
                }  
                

                const sanctionAmt = jsonData?.dmemo_funding_per_vehicle || 0;
                const processingFeePer = jsonData?.dmemo_processing_fee_on_finance_amount_plus_gst || 0;

                const feeChargesPayableAmt = roundNumber((Number(sanctionAmt) * Number(processingFeePer) / 100)).toFixed(2);  
                setFeeChargesPayable(feeChargesPayableAmt);

                gstAmount = (feeChargesPayableAmt * 18) / 100; 
                setAmountOfProcessingFee(roundNumber(gstAmount)); 

                 
                const processingFeeIncludingGst = Number(jsonData?.dmemo_processing_fee_including_gst) || 0;
                const processingFeeExcludingGSTAmt = (Number(processingFeeIncludingGst) - Number(gstAmount)).toFixed(2);
                setLessProcessingFeeExcludingGST(processingFeeExcludingGSTAmt);
         
                let totalMarginMoneyReceiptAmtount = Number(jsonData?.irr_total_asset_price) || 0; 

               // let totalNetDisbursementAmount = Number(jsonData?.irr_total_asset_price) || 0;

                let totalNetDisbursementAmount = Number(jsonData?.dmemo_disbursement_amount_for_vehicle_including_box) || 0;
                
                if (totalDownPaymentByCustomer !== '') {
                   // totalNetDisbursementAmount -= Number(totalDownPaymentByCustomer) || 0;
                }  
               
                let totalMarginMoneyReceiptRequired = 0;
                if (jsonData?.dmemo_margin_money_all_vehicle !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_margin_money_all_vehicle) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_margin_money_all_vehicle) || 0;
                }
               /* if (processingFeeExcludingGSTAmt !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(processingFeeExcludingGSTAmt) || 0;
                    totalMarginMoneyReceiptRequired += Number(processingFeeExcludingGSTAmt) || 0;
                } */

                 if (feeChargesPayableAmt !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(feeChargesPayableAmt) || 0;
                    totalMarginMoneyReceiptRequired += Number(feeChargesPayableAmt) || 0;
                }

                if (gstAmount !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(gstAmount) || 0;
                     totalMarginMoneyReceiptRequired += Number(gstAmount) || 0;
                }
                if (dearlerSubventionDedcuteAmount !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(dearlerSubventionDedcuteAmount) || 0;
                     totalMarginMoneyReceiptRequired += Number(dearlerSubventionDedcuteAmount) || 0;
                     totalNetDisbursementAmount -= Number(dearlerSubventionDedcuteAmount) || 0;
                }

                 
                if (insuranceByCfplAmount !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(insuranceByCfplAmount) || 0;
                     totalMarginMoneyReceiptRequired += Number(insuranceByCfplAmount) || 0;
                    // totalNetDisbursementAmount -= Number(insuranceByCfplAmount) || 0;
                }  

                if (jsonData?.dmemo_pre_emi !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_pre_emi) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_pre_emi) || 0;
                }
                if (jsonData?.dmemo_file_charge !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_file_charge) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_file_charge) || 0;
                }
                if (jsonData?.dmemo_kli_amount !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_kli_amount) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_kli_amount) || 0;
                }
 
               

               // setTotalMarginMoneyReceiptAmt(totalMarginMoneyReceiptRequired.toFixed(2)); //old calculation
                setTotalMarginMoneyReceiptAmt(totalDownPaymentByCustomer);

                // setNetDisbursementAmt(totalMarginMoneyReceiptAmtount.toFixed(2)); //old calculation
                setNetDisbursementAmt(totalNetDisbursementAmount.toFixed(2));

                setIsReadyToModify(resultArr[0]?._isReadyToModify); 
            }
    
            const crifDetailsMaster = resultArr[0]?.additional_info?.crif_details || [];
            setCrifDetails(crifDetailsMaster);
    
            const bankDetailsMaster = resultArr[0]?.additional_info?.banking_details || [];
            setBankDetails(bankDetailsMaster);
    
            const camApprovalHistoryInfo = resultArr[0]?.additional_info?.cam_approval_history || [];
            setCamApprovalHistory(camApprovalHistoryInfo);
    
           
    
            const anchorCategoryMaster = resultArr[0]?.additional_info?.anchor_category_master || [];
            setAnchorCategories(anchorCategoryMaster);
    
            const speciallyAbledMaster = resultArr[0]?.additional_info?.specially_abled || [];
            setSpeciallyAbledArr(speciallyAbledMaster);
    
            const residenceTypesMaster = resultArr[0]?.additional_info?.residence_types || [];
            setResidenceTypesArr(residenceTypesMaster);
    
            const bankingUpiMaster = resultArr[0]?.additional_info?.banking_upis || [];
            setBankingUpiArr(bankingUpiMaster);
    
            const constitutionMaster = resultArr[0]?.additional_info?.constitutions || [];
            setConstitutionArr(constitutionMaster);
    
            const customerTypeMaster = resultArr[0]?.additional_info?.customer_type || [];
            setCustomerTypeArr(customerTypeMaster);
    
            const vehicleMakerMaster = resultArr[0]?.additional_info?.vehicle_maker || [];
            setVehicleMakerArr(vehicleMakerMaster);
    
            const vehicleUseMaster = resultArr[0]?.additional_info?.vehicle_use || [];
            setVehicleUseArr(vehicleUseMaster);
    
            const insuranceMaster = resultArr[0]?.additional_info?.insurance || [];
            setInsuranceArr(insuranceMaster);
    
            const vehicleModelsMaster = resultArr[0]?.additional_info?.vehicle_models || [];
            setVehicleModelsArr(vehicleModelsMaster);
    
            const businessValidationProofMaster = resultArr[0]?.additional_info?.business_validation_proof || [];
            setBusinessValidationProofArr(businessValidationProofMaster);
    
            const turnoverIncomeMaster = resultArr[0]?.additional_info?.turnover_income || [];
            setTurnoverIncomeArr(turnoverIncomeMaster);
    
            const workingCapitalCycleMaster = resultArr[0]?.additional_info?.working_capital_cycle || [];
            setWorkingCapitalCycleArr(workingCapitalCycleMaster);
    
            const accountTypeMaster = resultArr[0]?.additional_info?.account_type_master || [];
            setAccountTypeArr(accountTypeMaster);
             
          } 
        } catch (error) {
         // console.error("Error in getCAMDetailsData:", error);
        }
      };

    const getUploadLeadDocumentData = async () => {
        if (id !== undefined) {
            setPropLeadId(atob(id));
            setLeadId(propLeadId);

            const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id), 'api_calling_module' : "delivery_order" };
            // console.log("obj lead id- ", obj);
            const requestData = encryptData(obj);
            const response = actions.getUploadLeadDocument(requestData);

            response.then((result) => {
                // console.log("Promise resolved -  source data:", result); 
                if (result.data.success === 1) {
                    const results = result.data.data.data;
                    const resultArr = Object.keys(results).map((key) => results[key]);

                   // console.log("AllUploadLeadDocument = ",resultArr);
                   // alert('here');

                    setAllUploadLeadDocument(resultArr);
                }
            }).catch((error) => {
                //  console.error("Promise rejected -  source data :", error); 
            });
        }
    };

    useEffect(() => {
        if (isActive) { 
           
            getSanctionConfigData();
            getUploadLeadDocumentData();
           
           
        }
    }, [isActive]);

    /* useEffect(() => {
         if (id !== undefined) {
             getUploadLeadDocumentData(); 
         }
 
     }, [setAllUploadLeadDocument]); */

    useEffect(() => {
        if (id !== undefined) {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id) };
        const requestData = encryptData(obj);
        const response = actions.masterDocumentTypeData(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  source data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data.data
                const filteredResultArr = results.filter((item) => item.status === "1");
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.document_type.localeCompare(b.document_type)
                );
                setAllDocumentTypeData(sortedResultArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
        });
    }

    }, [setAllDocumentTypeData]);

    const handleDocumentFileChange = (e) => {
        const files = Array.from(e.target.files);
        const base64Files = [];

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Data = event.target.result;
                const fileName = file.name;
                base64Files.push({ file: base64Data, name: fileName });
                if (base64Files.length === files.length) {
                    setSelectedDocumentFiles(base64Files);
                }
            };
            reader.readAsDataURL(file);
        });
    };

     

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const filteredItems = (allUploadLeadDocument ?? []).filter(item =>
        item.formatetdID.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.assignedUser.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.statusName.toLowerCase().includes(searchQuery.toLowerCase())
    );


    const startIndex = (currentPage - 1) * config.ITEMS_PER_PAGE;
    const endIndex = startIndex + config.ITEMS_PER_PAGE;
    const paginatedItems = filteredItems.slice(startIndex, endIndex);
    const totalPages = Math.ceil(filteredItems.length / config.ITEMS_PER_PAGE);

    const onRowClickAction = (itemObj, btnAction) => {
        setViewModalInfo(itemObj);
        setOpen(true);
    }

    const veridateDoc = (data, actionStatus) => {

        const verifyDocStatus = (actionStatus) ? 1 : 0;
        const params = { "id": data.id, "status": verifyDocStatus, "params":data };

        const requestData = encryptData(params);
        const response = actions.verifyDocuments(requestData);
        response.then((result) => {
            if (result.data.success === 1) {
                toast.success(result.data.message, {
                    position: "top-right",
                });
                getUploadLeadDocumentData();
            } else {
                toast.error(result.data.message, {
                    position: "top-right",
                });
            }
        }).catch((error) => {
            toast.error(error, {
                position: "top-right",
            });
        });
    };

    const handleVerifyAction = (event, item) => { 
        setIsVerifyDocChecked(event.target.checked)
        veridateDoc(item, event.target.checked);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleToggle = () =>{
        setSanctionFormStatus(prevState => !prevState); 
        getSanctionConfigData();
    }

    const handleToggleUpdateDetails = () =>{
        setEnableUpdatePdfDetails(prevState => !prevState); 
    }

    const handleToggleSaveDetails = () =>{ 
        getSanctionConfigData();
    }

    const handleSourceDealerChange = (event) =>{
          setSubjectivityDoDetails(event.target.value);
    }

    const btnOpenUploadMissingData = (item) => {
       setOpenAmt(true);
       setEnachItem(item);
     }

    const handleFormChange = (event) =>{
        if(event.target.name ==='refDoNo'){
             setRefDoNo(event.target.value);
        }

        if(event.target.name ==='dearlerSubventionDedcuteAmount'){
             setDearlerSubventionDedcuteAmount(event.target.value);
        }

        if(event.target.name ==='doDate'){
            setDoDate(event.target.value);
       }

        if(event.target.name ==='dealerName'){
            const dealerInfo = allDealers.find(doc => doc.name === event.target.value);
           // setRefDoNo(event.target.value);
            setDealerName(dealerInfo?.name);
            setDealerAddress(dealerInfo?.address);

            setDealerBankName(dealerInfo?.bank_name);
            setDealerAccountNo(dealerInfo?.account_no);
            setDealerIfsc(dealerInfo?.ifsc);
            setDealerBenificaryName(dealerInfo?.benificary_name);  
        }

        if(event.target.name ==='insuranceFor'){
            setInsuranceFor(event.target.value); 
            if(event.target.value === ''){
                setInsuranceFor('For insurance by ckers');
            } 
         }
        if(event.target.name ==='dealerSubvention'){
            setDealerSubvention(event.target.value);
            if(event.target.value === ''){
                setDealerSubvention('Dealer Subvention');
            }
        }

        if(event.target.name ==='loanAmountValue'){
            setLoanAmountValue(event.target.value); 
        }

        if(event.target.name ==='processingFeeOnFinanceAmountPlusGSTValue'){
            setProcessingFeeOnFinanceAmountPlusGSTValue(event.target.value); 
        }

        if(event.target.name ==='lessProcessingFeeIncludingGSTValue'){
            setLessProcessingFeeIncludingGSTValue(event.target.value); 
        }

        if(event.target.name ==='lessInsuranceByKotakMahindraValue'){
            setLessInsuranceByKotakMahindraValue(event.target.value); 
        }

        if(event.target.name ==='lessPreEmiTill5THJanValue'){
            setLessPreEmiTill5THJanValue(event.target.value); 
        }

        if(event.target.name ==='fileChargeValue'){
            setFileChargeValue(event.target.value); 
        }

        if(event.target.name ==='netDisbursementValue'){
            setNetDisbursementValue(event.target.value); 
        }

        if(event.target.name ==='nameOfSupplierDealerValue'){
            setNameOfSupplierDealerValue(event.target.value); 
        }

        if(event.target.name ==='exShowroomPriceValue'){
            setExShowroomPriceValue(event.target.value); 
        }

        if(event.target.name ==='assetValueVehicleVehcilesValue'){
            setAssetValueVehicleVehcilesValue(event.target.value); 
        }

        if(event.target.name ==='noOfAssetValue'){
            setNoOfAssetValue(event.target.value); 
        }

        if(event.target.name ==='insuranceAmounByDealerValue'){
            setInsuranceAmounByDealerValue(event.target.value); 
        }

        if(event.target.name ==='totalOnRoadPriceValue'){
            setTotalOnRoadPriceValue(event.target.value); 
        }
 
 
        if(event.target.name ==='insuranceForValue'){
            setInsuranceForValue(event.target.value); 
        }

        if(event.target.name ==='dealerSubventionValue'){
            setDealerSubventionValue(event.target.value); 
        }
         
         
    }

    const [htmlContent, setHtmlContent] = useState('');
    const editorRef = useRef(null);
    

    const handleInput = () => {
        setHtmlContent(editorRef.current.innerHTML);
    };

    const [formRejectitem, setFormRejectitem] = useState({
      notes: '',
    });

   /* const btnOpenRejectData = (approveBtnAction,sendEmail='0') => {    // buttonFun 
        setApproveBtnAction(approveBtnAction);
        setOpenUploadDoc(true);
        setSendEmailBtnAction(sendEmail);
    };
 */
    const btnUploadHandler = (btnAction,sendEmail='0') => {    // buttonFun 
        setUploadBtnAction(btnAction);
        setOpenUploadDoc(true);
        setSendEmailBtnAction(sendEmail);
    };

    const btnViewDetailsHandler = (apiResponse,sendEmail='0') => {    // buttonFun 

        const parsedDetails =  apiResponse !== '' ? JSON.parse(apiResponse) : [];
        setViewDetailsModalInfo(parsedDetails);
        setViewDetailsOpen(true); 
    };

    const handleViewDetailsClose = () => {
        setViewDetailsOpen(false);
        setViewAllDetailsOpen(false);
    };

    const handleCloseUploadDoc = () => {     // Modal onclick closedFun
        setUploadBtnAction(0);
        setOpenUploadDoc(false);
        setSendEmailBtnAction(0);
       };


       const checkDocumentType = (data) => {
        return data.startsWith("dynamicDocument^"); 
      };

       const handleDocumentsFormSubmit = (data) => {

        setPropLeadId(atob(id));
        setLeadId(propLeadId);

        let documentTypeName = '';
        let documentTypeStatus = 'static';
        if(data.document_type === undefined){
            documentTypeName = '';
        }else{
            const docTypeOption = allDocumentTypeData.find(doc => doc.id === data.document_type);
            console.log("docTypeOption = ", docTypeOption);
            documentTypeName = docTypeOption?.document_type;
            const checkStatus = checkDocumentType(data.document_type); 
            if(checkStatus){
               documentTypeStatus = 'dynamic';
            }
        }

        if (data.document_type.trim() === "") {
            toast.error("No document type has been selected.", {
                position: "top-right",
            });
        } else if (!selectedDocumentFiles || selectedDocumentFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else if (data.document_note.trim() === "") {
            toast.error("Note is blank.", {
                position: "top-right",
            });
        } else if (data.registration_no.trim() === "" && uploadBtnAction === 'MSME Certificate') {
            toast.error("Registration No is blank.", {
                position: "top-right",
            });    
        } else {

            if(uploadBtnAction !== 'MSME Certificate'){
                data.registration_no = '';
            }            
            const params = { "lead_id": propLeadId, "document_type": data.document_type, "document_note": data.document_note, "document_file": selectedDocumentFiles,"uploadBtnAction" :uploadBtnAction ,"registration_no" :  data.registration_no ,"documentTypeName": documentTypeName, "documentTypeStatus" : documentTypeStatus};

            const requestData = encryptData(params);
            const response = actions.addEditLeadDocument(requestData, navigate);

            response.then((result) => {
                // console.log("Promise resolved - addEditLeadDocument form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });

                    const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": propLeadId };
                    // console.log("obj lead id- ", obj);
                    const requestData = encryptData(obj);
                    const response = actions.getUploadLeadDocument(requestData);

                    response.then((result) => {
                        // console.log("Promise resolved -  source data:", result); 
                        if (result.data.success === 1) {
                            const results = result.data.data.data;
                            const resultArr = Object.keys(results).map((key) => results[key]);

                           
                            setAllUploadLeadDocument(resultArr);
                        }
                    }).catch((error) => {
                        //  console.error("Promise rejected -  source data :", error); 
                    });

                    reset();
                    setSelectedDocumentFiles("");
                    getSanctionConfigData();
                    getUploadLeadDocumentData();
                 } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
        }

         const btnOpenRejectData = (approveBtnAction,sendEmail='0') => {    // buttonFun 
            setApproveBtnAction(approveBtnAction);
            setOpenRejectAmt(true);
            setSendEmailBtnAction(sendEmail);
        };
    
        const handleCloseRejectAmt = () => {     // Modal onclick closedFun
            setApproveBtnAction(0);
            setOpenRejectAmt(false);
            setSendEmailBtnAction(0);
            };
    
            const handleRejectFormSubmit = (data) => {
                if (data.notes === '') {
                toast.error("Notes is required.", {
                    position: "top-right",
                });
                } else { 
                
                    if(approveBtnAction === '1'){
                        getSanctionConfigData('approve',data.notes);
                    }
                    
                    if(approveBtnAction === '2'){
                        getSanctionConfigData('reject',data.notes);
                    }
    
                    if(approveBtnAction === '3'){
                    getSanctionConfigData('reversal',data.notes);
                }
                }
            }

        const handleAmtRejectChange = (e) => {
            const totalAmt = e.target.value;
            setFormRejectitem((prevState) => ({
              ...prevState,
              totalAmt,
            }));
          }

        const printRef = useRef();
        const handleDownloadPdf = async () => {
            const element = printRef.current;
            if (!element) {
              console.error('Element not found');
              return;
            }
            const canvas = await html2canvas(element) ;
            if (canvas.width === 0 || canvas.height === 0) {
              console.error('Captured canvas has invalid dimensions');
              return;
            }
            const data = canvas.toDataURL('image/png');
            const pdf = new JsPDF();
            const imgProperties = pdf.getImageProperties(data);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
          
            pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);
            const timestamp = new Date().toISOString();
            const filename = `delivery_order_${timestamp}.pdf`;
            pdf.save(filename);
          };


    const toggleSection = (tabName) => {

      //  alert(tabName);

        if (tabName === 'FI') {
            setIsFIOpen(!isFIOpen);
        }

        if (tabName === 'Sanction Letter Pending Items') {
            setIsSanctionLetterPendingItemsOpen(!isSanctionLetterPendingItemsOpen);
        }

        if (tabName === 'Agreement') {
            setIsAgreementOpen(!isAgreementOpen);
        }

        if (tabName === 'Signature') {
            setIsSignatureOpen(!isSignatureOpen);
        } 

        if (tabName === 'Repayment Details') {
            setIsRepaymentDetailsOpen(!isRepaymentDetailsOpen);
        }


        if (tabName === 'Insurance Details') {
            setIsInsuranceDetailsOpen(!isInsuranceDetailsOpen);
        }

        if (tabName === 'MSME Certificate') {
            setIsMSMECertificateOpen(!isMSMECertificateOpen);
        }
    };

// UPI REGISTRATION START 
  // const [enchUPIitem, setEnachUPIitem] = useState([]);
  const [enchUPIitem, setEnachUPIitem] = useState({
    totalAmt: '',
    upiDebitDate: '',
  });
  
  const [openUPIAmt, setOpenUPIAmt] = useState(false);
  const [proposedUPIAmt, setproposedUPIAmt] = useState('');

  const btnOpenUPIData = (item) => {    // buttonFun
    setOpenUPIAmt(true);
    setEnachUPIitem(item);
    console.log("item Details 123", item);
  };

  const handleCloseUPIAmt = () => {     // Modal onclick closedFun
    setOpenUPIAmt(false);
    setEnachUPIitem([]);
  };

  const handleAmtUPIChange = (e) => {
    const totalAmt = e.target.value;
    setEnachUPIitem((prevState) => ({
      ...prevState,
      totalAmt,
    }));
  }

  const handleUPIDateChange = (e) => {
    const upiDebitDate = e.target.value;
    setEnachUPIitem((prevState) => ({
      ...prevState,
      upiDebitDate,
    }));
  }

  const handleUPIFormSubmit = (data) => { 
    console.log("ModalUPIHandle", data.emi_amount1);
  
    if (data.emi_amount1 === '') {
      toast.error("UPI Amount is required.", {
        position: "top-right",
      });
    } else if (data.debit_date1 === '') {
      toast.error("UPI Debit date is required.", {
        position: "top-right",
      });
    } else {
      enchUPIitem.totalAmt = data.emi_amount1;
      enchUPIitem.upiDebitDate = data.debit_date1;
      console.log("Updated enchUPIitem: ", enchUPIitem);
      onsendUPIRegistrationAction(enchUPIitem);
    }
  }
  
  const onsendUPIRegistrationAction = (item) => {  
    setPreloaderStatus(true); 
    
    // alert(item.emi_amount);
    const params = { 'lead_id': atob(id), 'application_id': atob(id),'brief' :'send_sms_to_user' ,'action' :'send_upi_link_to_user' ,'call_api_from' :'Lead', 'proposed_debit_date': item.upiDebitDate, 'proposed_amount': item.totalAmt, 'api_response': enchUPIitem};
    console.log("onsendUPIRegitrationDataShowParams", params);
    const requestData = encryptData(params);
    const response = actions.sendEnachUPIRegistrationDetails(requestData);
    response.then((result) => {         
        if (result.data.success === 1) { 
            console.log("response = ", result.data.data); 
            setPreloaderStatus(false);
                 toast.success(result.data.message, {
                     position: "top-right",
                 });
                const obj = { 'start': '0', 'length': config.MAX_RECORDS, "user_role_type": userRoleType,
                  "is_cam_leads": isCamChecked };
                const requestData = encryptData(obj);
                const response = actions.leadsData(requestData);
                response.then((result) => {
                  console.log("Promise resolved -  lead list:", result);
                  if (result.data.success === 1) {
                    setShowLeadDetails(true);
                    const results = result.data.data.data;
                    const resultArr = Object.keys(results).map((key) => results[key]);
                    setAllLeads(resultArr);
                    handleCloseUPIAmt();
                  }
                }).catch((error) => {
                  console.error("Promise rejected -  lead list:", error);
                });   
            
        } else {
            setPreloaderStatus(false);
            toast.error(result.data.message, {
                position: "top-right",
            });
        }

        setOpenAmt(false); 
        setProposedAmt('');
        setProposedDebitDate('');
        setEnachItem([]); 

        reset();
        setSelectedDocumentFiles("");
        getSanctionConfigData();
        getUploadLeadDocumentData();
    }).catch((error) => {
        setPreloaderStatus(false);
        toast.error(error, {
            position: "top-right",
        });
    });

 };  

  // UPI REGISTRATION END


  const handleAmtChange = (e) => {
    const amt = e.target.value;
     setProposedAmt(amt);
  };

  const handleDebitDateChange = (e) => {
    const date = e.target.value;
     setProposedDebitDate(date);
  };

  const handleCamChange = (event) => { 
    setIsCamChecked(event.target.checked);
  };

  const handleCloseAmt = () => { 
    setOpenAmt(false); 
    // setProposedAmt('');
   // setProposedDebitDate('');
    setEnachItem([]); 
  };

  const onSendEnachRegistrationAction = (item) => {  
      setPreloaderStatus(true); 
      
      // alert(item.emi_amount);
      const params = { 'lead_id': atob(id), 'application_id': atob(id),'brief' :'send_sms_to_user' ,'action' :'send_enach_link_to_user' ,'call_api_from' :'Lead','proposed_amount' : item.emi_amount,'proposed_debit_date' : item.debit_date};
      const requestData = encryptData(params);
      const response = actions.sendEnachRegistrationDetails(requestData);
  
      response.then((result) => {
          // console.log("Promise resolved - add/edit lead form:", result);
           
          if (result.data.success === 1) { 
              console.log("response = ", result.data.data); 
              setPreloaderStatus(false);
                toast.success(result.data.message, {
                    position: "top-right",
                }); 
          } else {
              setPreloaderStatus(false);
              toast.error(result.data.message, {
                  position: "top-right",
              });
          }
  
          setOpenAmt(false); 
          setProposedAmt('');
          setProposedDebitDate('');
          setEnachItem([]);

          reset();
          setSelectedDocumentFiles("");
          getSanctionConfigData();
          getUploadLeadDocumentData();
      }).catch((error) => {
          setPreloaderStatus(false);
          toast.error(error, {
              position: "top-right",
          });
      });
  
   };

  const handleFormSubmit = (data) => { 
      console.log("handleFormSubmit , ",data);
  
      if(data.emi_amount ===''){
        toast.error("Amount is required.", {
          position: "top-right",
        }); 
     }else if(data.debit_date ===''){
        toast.error("Debit date is required.", {
          position: "top-right",
        });  
      }else{
  
        // setProposedAmt(data.emi_amount);
       // setProposedDebitDate(data.debit_date);
        enachItem.emi_amount =  data.emi_amount;
        enachItem.debit_date =  data.debit_date;
        onSendEnachRegistrationAction(enachItem);
      }
      
   }

    const esignOtherActionHandler = (id,sectionId, sectionName, tabName,apiResponse='') => {
 
            if( tabName === 'esign_view'){
                const parsedDetails =  apiResponse !== '' ? JSON.parse(apiResponse) : [];
                setViewDetailsModalInfo(parsedDetails);
              //  setJsonViewDetailsModalInfo(apiResponse);
                setViewAllDetailsOpen(true); 

                agreementEsignOtherActionHandler(id,sectionId, sectionName, tabName,apiResponse);
            }else if( tabName === 'esign_cancel'){ 
                if (window.confirm("Are you sure you want to cancel agreement?")) {
                    agreementEsignOtherActionHandler(id,sectionId, sectionName, tabName,apiResponse);
                }  
            } 
        }
  
    const agreementEsignDownloadHandler = (documentId,propLeadId) => {
        if (!documentId) {
            toast.error("Invalid document ID");
            return;
        } 
        const loggeIdUserId = localStorage.getItem('loggeIdUserId');
 
        fetch(`${config.API_BASE_URL}download_esign_agreement`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ "documentId" : documentId, "section_id" : propLeadId , "lead_id" : propLeadId , "user_id" : loggeIdUserId})
        })
            .then(response => { 
            console.log("response = ", response); 
            if (!response.ok) {
                return response.json().then(err => Promise.reject(err));
            }
            return response.blob();
            })
            .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            const uniqueName = `esign_${documentId}_${Date.now()}.pdf`

            link.href = url;
            link.download = uniqueName;
            link.click();
            window.URL.revokeObjectURL(url);
            })
            .catch(error => {
            console.error("Download error:", error);
            toast.error("Unable to download agreement");
            });  
    };


    const agreementEsignOtherActionHandler = ( leadId='',sectionId, sectionName, actionName,apiResponse='') => { 
       // alert(actionName); 

            const params = { "section_id": sectionId, "section_name": sectionName, "actionName": actionName};

            const requestData = encryptData(params);
            const response = actions.agreementEsignOtherAction(requestData, navigate);

            response.then((result) => {
                 console.log("agreementEsignOtherAction : ", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
 
                 } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }

                 getSanctionConfigData();
                 getUploadLeadDocumentData();
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
    };
 
   const agreementEsignHandler = (actionName,sectionId='',sectionName='') => { 
       // alert(actionName); 

            const params = { "section_id": sectionId, "section_name": sectionName, "actionName": actionName};

            const requestData = encryptData(params);
            const response = actions.postEsignAgreement(requestData, navigate);

            response.then((result) => {
                 console.log("postEsignAgreement : ", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
 
                 } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }

                 getSanctionConfigData();
                 getUploadLeadDocumentData();
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
    };

    const RenderObject = ({ data }) => {
        if (!data) return null;

        if (typeof data === "object" && !Array.isArray(data)) {
            return (
            <table className="table-auto w-full border-collapse border border-gray-300 mb-4">
                <tbody>
                {Object.entries(data).map(([key, value]) => (
                    <tr key={key}>
                    <td className="border px-2 py-1 font-semibold capitalize">
                        {key}
                    </td>
                    <td className="border px-2 py-1">
                        { key === 'photo' ? (
                            <>
                            <img
                                src={`data:image/png;base64,${value}`}
                                alt="Preview"
                                style={{ width: '200px' }} />
                            </>

                        ) : (
                            <>
                            {typeof value === "object" ? (
                            <RenderObject data={value} />
                            ) : (
                            String(value)
                            )}
                        </>
                        )}
                    </td>
                    </tr>
                ))}
                </tbody>
            </table>
            );
        }

        if (Array.isArray(data)) {
            return (
            <div className="space-y-2">
                {data.length === 0 ? (
                <div className="ml-4 italic text-gray-500">No Data</div>
                ) : (
                data.map((item, index) => (
                    <div key={index} className="ml-4">
                    <div className="font-semibold">[{index + 1}]</div>
                    <RenderObject data={item} />
                    </div>
                ))
                )}
            </div>
            );
        }

        return <span>{String(data)}</span>;
        };

    return (
        <>
<div id="main-wrap" className='mt-4'>
<div className='row justify-content-between'>
<h5 className="fw-bold" title={userRoleType}>Delivery Order</h5>
{(userRoleType === "Credit" || userRoleType === "Manager-" || userRoleType === 'Superadmin' || userRoleType === 'Credit Head-' || userRoleType === 'Credit Operations') && (
<div className="col-md-12 mb-3">
    <button type="button" className="btn btn-primary text-white" onClick={handleToggle}  title="Visible To : Credit , Manager ,Credit Operations and Superadmin Users" >
    {sanctionFormStatus ? 'Go Back' : 'Show Delivery Order'}
    </button> 

    {( (userRoleType === "Credit" || userRoleType === 'Manager-' ||   userRoleType === 'Superadmin') ) && (
     <button type="button" className="btn btn-warning text-white float-right" onClick={clickCcmTab} title="Visible To : Credit and Superadmin Users" >
      { isReadyToModify ? "Update Sanction Terms Details" : "Sanction Terms Details" }
    </button>
    )} 
</div> 
)}

<div className=""> 

{ ( !sanctionFormStatus) ?(<>
<div className='row'>
{activeAccordionSections.map((sectionInfo, sectionIndex) => {
    const matchingDocs = activeAllSancationDocs.filter(
        (doc) => doc.doc_section === sectionInfo
    );
    let isOpenSection = false;
    if (sectionInfo === 'Sanction Letter Pending Items') {        
        isOpenSection = isSanctionLetterPendingItemsOpen;
    }

    if (sectionInfo === 'Agreement') {
        isOpenSection = isAgreementOpen;
   }


    if (sectionInfo === 'Signature') {
         isOpenSection = isSignatureOpen;
    }

   
    if (sectionInfo === 'Repayment Details') {
         isOpenSection = isRepaymentDetailsOpen;
    }

    if (sectionInfo === 'Insurance Details') {
        isOpenSection = isInsuranceDetailsOpen;
   }

   if (sectionInfo === 'MSME Certificate') {
    isOpenSection = isMSMECertificateOpen;
    }

    return (
        <div key={sectionIndex} className="col-md-12">
            <div className={ (sectionInfo==='Sanction Letter Pending Items') ? "collapsible-section-red" : "collapsible-section"}>

                <button                   
                    className={ (sectionInfo==='Sanction Letter Pending Items') ? "section-header-red btn-noborder" : "section-header btn-noborder"}
                    onClick={() => toggleSection(sectionInfo)}
                >
                    <h5>{sectionInfo}</h5>
                    <span>{isFIOpen ? '-' : '+'}</span>
                </button> 
                {isOpenSection && (
                   
                   
                   <div className="section-content" style={sectionInfo === 'Sanction Letter Pending Items' 
                        ? { borderTop: "1px solid #f03d3d", padding: "30px 10px 10px 10px" } 
                        : { borderTop: "1px solid #86bcb9", padding: "30px 10px 10px 10px" }
                      }>
                        
                        { sectionInfo === 'Agreement' && ( 
                            <>  
                                <div className="col-md-12 mb-3 row">
                                     {digioEsignDetails?.signing_parties?.map((signingInfo, signingIndex) => {
                                    // Find the matching document in allUploadLeadDocument
                                    return (
                                        <>  
                                            <div className="col-md-12"  >  
                                             {signingInfo.name} - <span className= {signingInfo.status === 'signed' ?  "badge btn btn-success text-white" : (signingInfo.status === 'requested' ?  "badge btn btn-primary text-white" : "badge btn btn-danger text-white")}>{signingInfo.status}</span>

                                             {signingInfo.status === 'signed' && signingInfo?.esign_id!== '' && ( 
                                                <>
                                                &nbsp;
                                                <a
                                                href={`#`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    agreementEsignDownloadHandler(signingInfo.esign_id,propLeadId);
                                                }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                >
                                                 <i className="nav-icon bi bi-download">&nbsp;</i>
                                                </a>


                                                

                                                    &nbsp;
                                                 <a
                                                href={`#`}
                                                onClick={(e) => {
                                                    e.preventDefault(); 
                                                     esignOtherActionHandler(propLeadId,propLeadId,'lead',"esign_view",signingInfo.responseData);
                                                }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                >
                                               <i className="nav-icon bi bi-eye">&nbsp;</i>
                                                </a>
 


                                                 &nbsp;
                                                <a
                                                href={`#`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    esignOtherActionHandler(propLeadId,propLeadId,'lead',"esign_cancel",signingInfo.responseData); 
                                                }}
                                                target="_blank"
                                                rel="noopener noreferrer" 
                                                >
                                                 <i className="nav-icon bi bi-trash text-danger">&nbsp;</i>
                                                </a>
                                                 
                                                </>
                                             )}
                                            
                                               <div style={{ fontSize: "11px", color: "rgb(100 97 97)" }}>
                                                    {signingInfo?.formattedUpdatedDate && (
                                                    <>
                                                        On : {signingInfo.formattedUpdatedDate}&nbsp;&nbsp;&nbsp;
                                                    </>
                                                    )}

                                                    {digioEsignDetails?.createdByName && (
                                                     <>
                                                        By : {digioEsignDetails.createdByName}
                                                    </>
                                                    )}

                                                    {signingInfo?.formattedExpireOn && (
                                                    <div>
                                                       <b>Expire On </b>: {signingInfo.formattedExpireOn} 
                                                    </div>
                                                    )}
                                                </div>
                                              <hr/>
                                            </div>                                             
                                        </>
                                    )})}
                                     {digioEsignDetails?.attemptedCount && (
                                        <div>
                                            Attempts : {digioEsignDetails?.attemptedCount}/4 (Max. 4 attempts)
                                            <div>
                                                Last Action By : {digioEsignDetails.createdByName} 
                                               <span className="text-right float-right"> On : {digioEsignDetails.created_at_date} </span>
                                            </div>
                                        </div>
                                     )}                                    
                                </div>
                                { digioEsignDetails?.attemptedCount > 3 ?

                                ( <>
                                  &nbsp;
                                </>) : 
                                (
                                <>
                                <div className="col-md-4 mb-5" >  
                                  <button                   
                                    className= "btn btn-primary float-right"
                                    onClick={() => agreementEsignHandler('online agreement',propLeadId,'lead','all')}
                                >
                                    Online Agreement (E-sign)
                                </button>
                                </div> 
                                </> 
                                )}
                                <hr/> 
                              <div className= "col-md-12 mb-3" ><b>Manual Agreement</b> </div> 
                               <hr/>   
                                <div className= "col-md-12 mb-3"  >&nbsp; </div> 
                            </>
                        ) }

                        
                        {matchingDocs.map((docInfo, index) => {
                            // Find the matching document in allUploadLeadDocument
                            const matchedDoc = allUploadLeadDocument.find((item) => item.documentTypeName === docInfo.doc_name);
                            return (
                                <>  
                                    { ( matchedDoc)  ? (
                                        <>
                                        { (sectionInfo==='Sanction Letter Pending Items') ? 
                                        (<>
                                             {matchedDoc.verified_status !== "1" && (
                                                <>
                                                    <div key={index} className= "col-md-12 mb-3 row">
                                                        <div className= "col-md-4" title="section 1">
                                                            <b>{docInfo.doc_name}</b>
                                                            </div>   
                                                        <div className= "col-md-4">    
                                                            <span className="text-danger">NOT VERIFIED</span>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </>) : 
                                        (
                                        <>
                                          <div key={index}  className= "col-md-12 mb-3 row"> 

                                            <div className= "col-md-4" title={`section 2 ${matchedDoc.id}`}>      
                                                 <b>{docInfo.doc_name}</b>  
                                             </div>
                                            { (matchedDoc.document !=='') && (
                                             <>   
                                            <div className= "col-md-4">  
                                                <a target="new"  
                                                href={ (sectionInfo==='Signature' || sectionInfo==='Agreement') ?  matchedDoc.document : matchedDoc.document}className="text-decoration-none">
                                                    Download File
                                                </a>
                                                &nbsp; Uploaded On {matchedDoc.created_date} by {matchedDoc.createdByName} &nbsp;
                                                {matchedDoc?.registration_no && (
                                                    <button
                                                        type="button"
                                                        onClick={() => btnViewDetailsHandler(matchedDoc.api_response)}
                                                        style={{ color: "green", background: "none", border: "none", cursor: "pointer" , width: "auto !important",
                                                            float: "right" }}
                                                        aria-label="View details"
                                                    >
                                                        <i className="nav-icon bi bi-eye">&nbsp;</i>
                                                    </button>
                                                    )}

                                            {sectionInfo === 'MSME Certificate' && (
                                                    <>
                                                        {matchedDoc?.registration_no !=='' && (
                                                            <>
                                                            <br/>Registration No - {matchedDoc?.registration_no}
                                                            </>
                                                        )}
                                                    </>
                                                )}         
                                            </div>
                                            </>
                                            ) }

                                            {matchedDoc.verified_status !== "1" ? (
                                                <>
                                                    <div className= "col-md-4"> 
                                                        <span className="text-danger">NOT VERIFIED</span>

                                                        
                                                        {(userRoleType === "Credit" || userRoleType === "Manager" || userRoleType === 'Superadmin' || userRoleType === 'Credit Operations') && (
                                                            <>
                                                                {(matchedDoc.documentTypeStatus === 'dynamic' && matchedDoc.notMatchingDetails !== '') ?
                                                                    (
                                                                        <>
                                                                            <span className='float-right'>
                                                                                {matchedDoc.verified_status !== '1' ? (
                                                                                    <>
                                                                                        {(matchedDoc.notMatchingDetails !== '') ? JSON.parse(matchedDoc.notMatchingDetails) : ''}
                                                                                    </>
                                                                                ) : (
                                                                                    <></>
                                                                                )}
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {matchedDoc.verified_status !== '1' ? (
                                                                                <span className='float-right'>
                                                                                    <input type='checkbox' name='document_verify' id='document_verify'
                                                                                        {...register('document_verify')}
                                                                                        onChange={(event) => handleVerifyAction(event, matchedDoc)}
                                                                                    /> <b>Verify</b></span>
                                                                            ) : (
                                                                                <> </>
                                                                            )}
                                                                        </>
                                                                    )}
                                                            </>
                                                        )}
                                                    </div>        
                                                </>
                                            ) : (
                                                <>
                                                    <div className= "col-md-4"> 
                                                        <span className='text-green'>Validated On</span> {matchedDoc.validated_date} by {matchedDoc.validatedByName}
                                                     
                                                        {(userRoleType === "Credit" || userRoleType === "Manager" || userRoleType === 'Superadmin' || userRoleType === 'Credit Operations') && (
                                                            <>
                                                                {(matchedDoc.documentTypeStatus === 'dynamic' ) ?
                                                                    (
                                                                        <>
                                                                            <span className='float-right'>
                                                                                {matchedDoc.verified_status !== '1' ? (
                                                                                    <>
                                                                                        {(matchedDoc.notMatchingDetails !== '') ? JSON.parse(matchedDoc.notMatchingDetails) : ''}
                                                                                    </>
                                                                                ) : (
                                                                                    <></>
                                                                                )}
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {matchedDoc.verified_status !== '1' ? (
                                                                                <span className='float-right'>
                                                                                    <input type='checkbox' name='document_verify' id='document_verify'
                                                                                        {...register('document_verify')}
                                                                                        onChange={(event) => handleVerifyAction(event, matchedDoc)}
                                                                                    /> <b>Verify</b></span>
                                                                            ) : (
                                                                                <> </>
                                                                            )}
                                                                        </>
                                                                    )}
                                                            </>
                                                        )}
                                                     </div> 
                                                </>
                                            )}

                                            
                                        </div>
                                        </>)}

                                        </>
                                    ) : (
                                        <>
        <div key={index} className={(docInfo.doc_name === "eNach" || docInfo.doc_name === 'UPI 2.0') ? "col-md-12 mb-3 row" : "col-md-12 mb-3 row" }> 

        {docInfo.doc_name === "eNach" && (() => {
            let ENachSentStatus = false;
            let ENachUserStatus = false;
            let ENachUserHtml = null;  
            let umrnNo = '';
            if (docInfo?.data?.id) {
                ENachSentStatus = true;
                if (docInfo?.data?.userEnachResponse?.response_status) {                   
                    
                    if (docInfo.data.userEnachResponse.response_status === "Success") {
                        if (docInfo.data.userEnachResponse?.itcArr?.UMRNNumber !== "") {
                            umrnNo = <span className="text-success">UMRN Number : {docInfo.data.userEnachResponse?.itcArr?.UMRNNumber}</span>;
                        }

                        ENachUserHtml = <div className="text-success" style={{ width: 'auto',float: 'left' }}>E-NACH process successfully done {docInfo?.data?.userEnachResponse?.createdByName !== '' && docInfo?.data?.userEnachResponse?.createdByName !== undefined ? (
                            <>
                              By System
                              <br />
                              Done on {docInfo?.data?.userEnachResponse?.enach_created_date}
                            </>
                          ) : (
                            ''
                          )}.</div>;
                        ENachUserStatus = true;
                    } else {
                        ENachUserHtml = <div className="text-danger" style={{ width: 'auto',float: 'left' }}>E-NACH process {docInfo.data.userEnachResponse.response_status}.</div>;
                    }
                }
            }

            return (
                <>
                    <div className= "col-md-4">
                        <b style={{ width: 'auto',float: 'left' }}>{docInfo.doc_name} {umrnNo}
                            </b>
                    </div>
                    {ENachSentStatus ? (
                        <> 
                         <div className= "col-md-4">
                            <div className="text-success" style={{ width: 'auto',float: 'left' }}>
                             SMS link sent successfully 
                             {docInfo?.data?.createdByName !=='' && docInfo?.data?.createdByName !== undefined ? (
                            <>
                              By {docInfo?.data?.createdByName}
                              <br />
                              Done on {docInfo?.data?.enach_created_date}
                            </>
                          ) : (
                            ''
                          )}
                            </div>
                            </div>
                            <div className= "col-md-4">
                             {ENachUserHtml}
                            </div>
                        </>
                    ) : (
                        <>
                             <div className= "col-md-4">
                                <div className="col-md-8">
                                        <button type="button" className={(ENachUserStatus) ? "d-none badge btn btn-success text-white float-right" : "badge btn btn-success text-white float-right"}
                                        onClick={(e) => {e.preventDefault(); /* onSendEnachRegistrationAction(item) */
                                        btnOpenUploadMissingData(docInfo)}}> 
                                        {preloaderStatus && (<>
                                        <div className="spinner-border small-preloader d-none" role="status" >
                                            <span className="visually-hidden">Loading...</span>
                                        </div></>)}
                                    E-NACH Registration
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </>
            );
        })()}


<>

{docInfo.doc_name === "UPI 2.0" && (() => {
    let UPISentStatus = false;
    let UPIUserStatus = false;
    let UPIUserHtml = null;  
    let umrnNo = '';
    if (docInfo?.data?.id) {
        UPISentStatus = true;
        if (docInfo?.data?.userUPIResponse?.response_status) {                   
            
            if (docInfo.data.userUPIResponse.response_status === "Success") {
                if (docInfo.data.userUPIResponse?.itcArr?.UMRNNumber !== "") {
                    umrnNo = <span className="text-success">UMRN Number : {docInfo.data.userUPIResponse?.itcArr?.UMRNNumber}</span>;
                }

                UPIUserHtml = <div className="text-success" style={{ width: 'auto',float: 'left' }}>UPI 2.0 process successfully done {docInfo?.data?.userUPIResponse?.createdByName !=='' && docInfo?.data?.userUPIResponse?.createdByName !== undefined ? (
                            <>
                              By System
                              <br />
                              Done on {docInfo?.data?.userUPIResponse?.enach_created_date}
                            </>
                          ) : (
                            ''
                          )}
                .</div>;
                UPIUserStatus = true;
            } else {
                UPIUserHtml = <div className="text-danger" style={{ width: 'auto',float: 'left' }}>UPI 2.0 process {docInfo.data.userUPIResponse.response_status}.</div>;
            }
        }
    }

    return (
        <>
            <div className= "col-md-4">
                 <b style={{ width: 'auto',float: 'left' }}>{docInfo.doc_name} {umrnNo}</b>
            </div>
            {UPISentStatus ? (
                <> 
                    <div className= "col-md-4">
                        <div className="text-success" style={{ width: 'auto',float: 'left' }}>
                          SMS link sent successfully 
                          {docInfo?.data?.createdByName !=='' && docInfo?.data?.createdByName !== undefined ? (
                            <>
                              By {docInfo?.data?.createdByName}
                              <br />
                              Done on {docInfo?.data?.enach_created_date}
                            </>
                          ) : (
                            ''
                          )}
                        </div>
                    </div>
                    <div className= "col-md-4">
                         {UPIUserHtml}
                    </div>
                </>
            ) : (
                <>
                    <div className= "col-md-4">
                        <div className="col-md-8 ">
                        <button style={{margin: '0.2rem 0rem'}}
                        type="button"
                        className="badge btn btn-primary text-white float-right "
                        onClick={(e) => {
                        e.preventDefault();
                        /* onSendEnachRegistrationAction(item) */
                        btnOpenUPIData(matchedDoc)
                        }
                        }
                        > 
                        {preloaderStatus && (<>
                        <div className="spinner-border small-preloader d-none" role="status" >
                            <span className="visually-hidden">Loading...</span>
                        </div></>)}
                         UPI REGISTRATION
                    </button>
                    </div>
                </div>
                </>
            )}
        </>
    );
})()}
                                    
                                    
                                        
    {(docInfo.doc_name !== 'eNach' && docInfo.doc_name !== 'UPI 2.0' ) && (
        <>
            <div className= "col-md-4" title="section 3"> 
                <b>{docInfo.doc_name}</b>
            </div>
            <div className= "col-md-4">  
                <span className= { sectionInfo==='Sanction Letter Pending Items' ? "text-danger": "text-danger" } >NOT UPLOADED</span>
            </div> 
        </>

    )}
</>
                                
                            </div>
                                        </>
                                    )}
                            </>
                            );
                        })}
             
             {sectionInfo !== 'Sanction Letter Pending Items' && (
                 <div className= "col-md-12" style={{ borderTop: "1px solid #ccc" }}> 
                    <div className="col-md-2 mb-2" style={{ paddingTop: "15px" }}>
                        <button
                        className="btn btn-default btn-border"
                        type="button"
                        style={{ width: "auto" }}
                        onClick={() => {
                            const validSections = [
                            'Signature',
                            'Agreement',
                            'Repayment Details',
                            'Insurance Details',
                            'MSME Certificate',
                            ];
                            if (validSections.includes(sectionInfo)) {
                            btnUploadHandler(sectionInfo);
                            }
                        }}
                        >
                        Upload More
                        </button>
                    </div>
                    </div>
                )}
    
                    {sectionInfo==='Sanction Letter Pending Items' && allLeadCheckLists.map((item, index) => ( 
                            <>
                            {(item.fieldInvestigationFalg === '1') ? (
                                <>
                               { /* 
                                 <div key={index} className="col-md-12 mb-2">
                                <b>{item.check_list_name}</b> {(item.section_name !== '') && (<> (<span
                                className={
                                    item.section_name === 'Lead'
                                        ? 'text-green'
                                        : item.section_name === 'Guarantor'
                                            ? 'text-primary'
                                            : 'text-warning'
                                }
                            >{(item.section_name === 'Lead') ? "Applicant" : item.section_name}</span> - {item.checklist_user_name})</>)}
                                    &nbsp; - Verified by system
                                </div>
                            */}
                                </>
                            ) : (
                                <>
                                <div key={index} className="col-md-12 mb-2 row">
                                    <div className= "col-md-4" title="section 4"> 
                                        <b>{item.check_list_name}</b> 
                                    
                                    {(item.section_name !== '') && (<> (<span
                                    className={
                                        item.section_name === 'Lead'
                                            ? 'text-green'
                                            : item.section_name === 'Guarantor'
                                                ? 'text-primary'
                                                : 'text-warning'
                                    }
                                >{(item.section_name === 'Lead') ? "Applicant" : item.section_name}</span>   {item.checklist_user_name})</>)}
                                </div>

                                    <div className= "col-md-4">
                                     <span className="text-danger">NOT VERIFIED</span>
                                    </div>
                                    </div>
                                </>
                            )}

                        </>
                    ))}


                    </div>
                )}
            </div>
        </div>
    );
})} 
 
</div>
 
 </>) :

 (
  <>
      <div>
       <div ref={printRef}>
          
            <div style={
                isReadyToModify
                ? { border: "1px solid grey", padding: "10px" }
                : { border: "1px solid grey", padding: "10px", background: "#dbfed4" }
            }>
             <div style={{ textAlign: "center"}}>
             {(camDetails?.cam_lender !=='' && camDetails?.cam_lender ==='Vivriti') ? (
                    <>
                    <div style={{ textAlign: 'center' }}>
                        <img src="/assets/vivriti-logo.png" className="login-logo-" alt="Vivriti Logo" style={{  display: "inline"}} />
                        </div>
                        <h4> Vivriti Capital Limited</h4>
                        Prestige Zackria Metropolitan, No. 200/1-8, 2nd Floor, Block 1, Anna Salai, Chennai - 600002
                    </>
                 ) : (
                    <>
                   <div style={{ textAlign: 'center' }}>
                 <img src="/assets/ckern-logo.png" className="login-logo-" alt="CKers Logo" style={{  display: "inline"}} />
                </div>
                <h4> cKers Finance Private Limited</h4>
                Building No-24-30, First Floor, Okhla Industrial Area Phase - III, New Delhi 110020, India
                 </>
                 )}
                 
             </div>
 
             <div>
             Reference No : { ( enableUpdatePdfDetails) ? (
                             <>
                              <input  
                                 id="refDoNo" name="refDoNo" 
                                 style={{ width: 'auto' }}
                                 className='form-control' {...register('refDoNo')} 
                                 value={refDoNo} 
                                 onChange={handleFormChange} 
                              /> 
                             </>
                         ) : (
                             <>
                              {refDoNo} 
                             </>
                         )}<br/>
                 Date :  { ( enableUpdatePdfDetails) ? (
                             <>
                              <input  
                                 id="doDate" 
                                 name="doDate" 
                                 type="date"
                                 style={{ width: 'auto' }}
                                 className='form-control' {...register('doDate')} 
                                 value={doDate} 
                                 onChange={handleFormChange} 
                              /> 
                             </>
                         ) : (
                             <>  
                              {doDate !=='' ? formatDateForValue(doDate) : ''} 
                              
                             </>
                         )},  <br/> <br/>      
                     To,<br/>
                        { ( enableUpdatePdfDetails) ? (
                             <>
                             <div className='row'>
                              <div className='col-3'> 
                                <select
                                id='dealerName'
                                name='dealerName'
                                className="form-select"
                                {...register('dealerName')}
                                value={dealerName}
                                onChange={handleFormChange}>
                                <option value='' >Please Select </option>
                                {
                                    allDealers.length > 0 && allDealers.map((option) => (
                                    <option value={option.name} >
                                        {option.name}
                                    </option>
                                    ))
                                }
                                </select>
                                </div>
                             </div>
                             </>
                         ) : (
                             <>
                              {dealerName} 
                             </>
                         )}<br/>
                     {dealerAddress}<br/><br/>
                     Dear Sir,  <br/>
                     <b>Re: Delivery Order</b><br/>
                     We have sanctioned Finance Facility to our Customer Name : {(camDetails?.dmemo_customer_name !=='') ? camDetails?.dmemo_customer_name : leadName}
                     <div>
                     With reference to agreement executed by the Customer in our favour, with respect to the loan facility and on the basis of the instruction of the customer, we will disbursed the following amount in your favour.
                     </div>
                     <div style={{ clear: 'both' }}>&nbsp;</div>
                     <div style={{ clear: 'both' }}><b>Disbursement Amount Details are as follows:</b></div>

                        <table style={{ border: '1px',width:'100%' }}>
                            <tr> 
                                <td style={{ borderWidth: '1px' }}><b>Model</b></td>
                                <td style={{ textAlign: 'right',borderWidth: '1px' }}> <b>{camDetails?.dmemo_vehicle_models}&nbsp;</b> </td>
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}><b>Manufacturer Name</b></td>
                                <td style={{ textAlign: 'right',borderWidth: '1px' }}><b>{camDetails?.cam_vehicle_maker}</b></td>
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}><b>Approved Loan Amount</b></td>
                                <td style={{ textAlign: 'right', borderWidth: '1px' }} title="Loan Amount from Sanction terms"><b>{camDetails?.dmemo_loan_amount}</b></td>
                            </tr>
                        </table>

<div style={{ clear: 'both' }}>&nbsp;</div>
 
 <table border="1" cellPadding="8" cellSpacing="0" style={{ borderCollapse: 'collapse', width : '100%' }}>
  <thead>
    <tr>
      <th  style={{ textAlign: 'left', backgroundColor : '#f2f2f2', borderWidth: '1px' }}>Payment Calculation For Dealer</th>

      <th  style={{ textAlign: 'left', backgroundColor : '#f2f2f2', borderWidth: '1px' }}>(%)</th>

      <th  style={{ textAlign: 'left', backgroundColor : '#f2f2f2', borderWidth: '1px' }}>Deductions</th>

      <th  style={{ textAlign: 'right', backgroundColor : '#f2f2f2', borderWidth: '1px' }}>Total(A)</th>
      
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style={{ borderWidth: '1px' }}>(A) Performa Invoice Amount</td>
      <td style={{ borderWidth: '1px' }}>&nbsp;</td>
      <td style={{ borderWidth: '1px' }}>&nbsp;</td>
      <td style={{ textAlign: 'right' , borderWidth: '1px'}} title="Total Asset price in IRR sheet" >{camDetails?.irr_total_asset_price}</td>
    </tr>
    <tr>
      <td style={{ borderWidth: '1px' }}>Less: Margin Money To Be Deposit with Dealer</td>
      <td style={{ borderWidth: '1px' }}>&nbsp;</td>     
      <td style={{ textAlign: 'right' , borderWidth: '1px'}} title="Margin Money- (All Vehicles) from Sanction terms">{camDetails?.dmemo_margin_money_all_vehicle}</td>
      <td style={{ borderWidth: '1px' }}>&nbsp;</td>
    </tr>
    <tr>
      <td style={{ borderWidth: '1px' }}>Less: Processing Fee</td>
      <td style={{ borderWidth: '1px' }} title="Processing Fee (%) from Sanction terms">{(camDetails?.dmemo_processing_fee_on_finance_amount_plus_gst !=='') && 
        (<>
        {camDetails?.dmemo_processing_fee_on_finance_amount_plus_gst}% 
        </>
        )}&nbsp;</td> 
            
      <td style={{ textAlign: 'right' , borderWidth: '1px'}} title="Processing Fee (Including GST) from Sanction terms">{feeChargesPayable}</td>

      <td style={{ borderWidth: '1px' }}>&nbsp;</td>
    </tr>
    <tr>
      <td style={{ borderWidth: '1px' }}>Less: GST on Processing Fee</td>
      <td style={{ borderWidth: '1px' }}>18%</td>     
      <td style={{ textAlign: 'right' , borderWidth: '1px'}}> {amountOfProcessingFee.toFixed(2)}</td>
      <td style={{ borderWidth: '1px' }}>&nbsp;</td>
    </tr>
   
    <tr>
      <td rowSpan="2" style={{ borderWidth: '1px' }}>Tentative Pre-EMI Calculated for the period from</td>
      <td style={{ borderWidth: '1px' }}>Expected Disbursal Date</td>
      <td style={{ borderWidth: '1px' }}>Pre-EMI date / 1st EMI date <span style={{ textAlign: 'right', float: "right" }}>{camDetails?.dmemo_pre_emi}</span></td>
      <td style={{ textAlign: 'right' , borderWidth: '1px'}} title="Pre-Emi from Sanction Terms">&nbsp;</td>
    </tr>
    <tr>
      <td style={{ borderWidth: '1px' }} title="Pre EMi End Date from Sanction Terms" >{(camDetails?.dmemo_pre_emi_end_date !=='') ? formatDateForValue(camDetails?.dmemo_pre_emi_end_date) : ''}</td>
      <td style={{ borderWidth: '1px' }} title="Pre EMi Start Date from Sanction Terms">{(camDetails?.dmemo_pre_emi_start_date !=='') ? formatDateForValue(camDetails?.dmemo_pre_emi_start_date) : ''}</td>
      <td style={{ borderWidth: '1px' }}>&nbsp;</td>
    </tr>
    <tr>
      <td style={{ borderWidth: '1px' }}>File Charge</td>
      <td colSpan="2" style={{  textAlign: 'right',borderWidth: '1px' }} title="File Charge from Sanction Terms">{!Number.isNaN(camDetails?.dmemo_file_charge) && camDetails?.dmemo_file_charge !== null ? Number(camDetails.dmemo_file_charge).toFixed(2): ""}</td>
      <td style={{ textAlign: 'right', borderWidth: '1px'}}>&nbsp;</td>
    </tr>
    <tr>
      <td style={{ borderWidth: '1px' }}>Credit life insurance</td>
      <td colSpan="2" style={{ textAlign: 'right' ,borderWidth: '1px' }} title="KLI Amount from Sanction Terms">{!Number.isNaN(camDetails?.dmemo_kli_amount) && camDetails?.dmemo_kli_amount !== null ? Number(camDetails.dmemo_kli_amount).toFixed(2): ""}</td>
      <td style={{  borderWidth: '1px'}}>&nbsp;</td>
    </tr>
    <tr>
      <td style={{ borderWidth: '1px' }} title="Margin Money- (All Vehicles) + Processing fees including GST + Dealer Subvention + Pre-EMI Amount"><strong>Total Margin Money Receipt Required<br/>(Including Insurance, Margin Money, Processing Fees)</strong></td>
      <td colSpan="2" style={{ borderWidth: '1px' }}>&nbsp;</td>
      <td style={{ textAlign: 'right' , borderWidth: '1px'}}><strong>{roundNumber(totalMarginMoneyReceiptAmt).toFixed(2)}</strong></td>
    </tr>

     <tr>
      <td colSpan="2" style={{ borderWidth: '1px' }}>Dealer Subvention Deducted by Ckers with 18% GST</td>
      <td style={{ textAlign: 'right' , borderWidth: '1px'}}>
      { ( enableUpdatePdfDetails) ? (
                <>
                <div className='row'>
                <div className='col-3'> 
                <input  
                    id="dearlerSubventionDedcuteAmount" name="dearlerSubventionDedcuteAmount" 
                    style={{ width: 'auto' }}
                    className='form-control' {...register('dearlerSubventionDedcuteAmount')} 
                    value={dearlerSubventionDedcuteAmount} 
                    onChange={handleFormChange} 
                /> 
                </div>
                </div>
                </>
            ) : (
                <>
                {dearlerSubventionDedcuteAmount} 
                </>
            )}

      </td>
      <td style={{ borderWidth: '1px' }}>&nbsp; </td>
    </tr>

    <tr>
      <td colSpan="2" style={{ borderWidth: '1px' }}>Insurance by CKers</td>
      <td style={{ textAlign: 'right' , borderWidth: '1px'}}>{roundNumber(insuranceByCKersAmt).toFixed(2)}</td> 
      <td style={{ borderWidth: '1px' }}>&nbsp; </td>
    </tr>
   

    <tr>
      <td style={{ borderWidth: '1px' }}><strong>NET DISBURSEMENT</strong></td>
      <td colSpan="2" style={{ borderWidth: '1px' }}>&nbsp;</td>
      <td style={{ textAlign: 'right', borderWidth: '1px'}}><strong>{roundNumber(netDisbursementAmt).toFixed(2)}</strong></td>
    </tr>
  </tbody>
</table>

<div style={{ clear: 'both' }}>&nbsp;</div>


<table style={{ border: '1px',width:'100%' }}>
        <tr> 
            <td style={{ borderWidth: '1px' }}><b>Benificary Name</b></td>
            <td style={{ borderWidth: '1px' }}> <b>{dealerBenificaryName}&nbsp;</b> </td>
        </tr>

        <tr> 
            <td style={{ borderWidth: '1px' }}><b>Bank Name</b></td>
            <td style={{ borderWidth: '1px' }}><b>{dealerBankName}</b></td>
        </tr> 
    
        <tr> 
            <td style={{ borderWidth: '1px' }}><b>Account No</b></td>
            <td style={{ borderWidth: '1px' }}><b>{dealerAccountNo}</b></td>
        </tr>
        
        <tr> 
            <td style={{ borderWidth: '1px' }}><b>IFSC Code</b></td>
            <td style={{ borderWidth: '1px' }}><b>{dealerIfsc}</b></td>
        </tr>
    </table>

<div style={{ clear: 'both' }}>&nbsp;</div>
 
<div style={{ clear: 'both' }}>
We request you to appropriate the payment towards the cost of the vehicle purchased by our customer from you. We hereby authorise you to register and deliver the vehicle of the above mentioned customer. The form 20 & 34 is also enclosed (as applicable). Validity of this DO is 08 days from the date of issue. <br/>
    
</div> 
 
<div style={{ clear: 'both' }}>&nbsp;</div>

<div style={{ clear: 'both' }}><b>Invoice to be raised as mentioned below.</b></div>
<table style={{ border: '1px',width:'100%' }}>
        <tr> 
            <td style={{ borderWidth: '1px' }}><b>Sold To</b></td>
            <td style={{ borderWidth: '1px' }}> <b>{(camDetails?.dmemo_customer_name !=='') ? camDetails?.dmemo_customer_name : leadName}&nbsp;</b> </td>
        </tr>

        <tr> 
            <td style={{ borderWidth: '1px' }}><b>Address to register</b></td>
            <td style={{ borderWidth: '1px' }}><b>{leadAddress}</b></td>
        </tr> 
    
        <tr> 
            <td style={{ borderWidth: '1px' }}><b>Hypothecation</b></td>
            <td style={{ borderWidth: '1px' }}><b>cKers Finance Pvt Ltd</b></td>
        </tr>
        
        
    </table>
 
                     <div style={{ clear: 'both' }}>&nbsp;</div>   
                     <div style={{ clear: 'both' }}>
                          { ( enableUpdatePdfDetails) ? (
                             <>
                              <textarea 
                                 style={{height:'auto'}} 
                                  rows="5" 
                                 id="source_dealer_details" name="source_dealer_details" 
                                 className='form-control' {...register('source_dealer_details')} 
                                 value={subjectivityDoDetails} 
                                 onChange={handleSourceDealerChange} 
                              /> 
                             </>
                         ) : (
                             <>
                             {subjectivityDoDetails !== '' ?  ( 
                                 <>
                                 <div
                                   style={{ paddingLeft: '15px' }}
                                   dangerouslySetInnerHTML={{
                                     __html: subjectivityDoDetails.replace(
                                       /\n/g,
                                       "<br />"
                                     ),
                                   }}
                                 />
                               </>
                             ) : (
                                 <>
                                 Payment will be release with in 2-3 days on receipt of the following documents. Please send the following Documents with our hypothecation endorsement to our office immediately on delivery of vehicle.<br />1. Original Invoice Chassis and Body.2. Photocopy of RC Book.<br />3. Copy of Comprehensive Insurance Policy with IDV coverage of 95% of Chassis and Body with 0% depreciation and cKers HP.<br />4. Photo of Delivery of the vehicle with customer and Dealer Staff or cKers Finance staff to be share.
                                 </>
                                 )
                             }
                             </>
                         )}
                    
                         
                     </div> 
                    <div >Please acknowledge a copy of this letter. </div>
                     <div style={{ clear: 'both',paddingTop: "20px" }}>&nbsp;</div>                     
                     Thanking you, <br/>
                     Your faithfully,<br/><br/>
                     <table style={{ width:'100%' }}>
                         <tr> 
                             <td> 
                             {(camDetails?.cam_lender !=='' && camDetails?.cam_lender ==='Vivriti') ? "For cKers Finance Pvt Ltd on Behalf of Vivriti Capital Limited" : "For cKers Finance Pvt Ltd" }   
                             <br/>
                             (Authorised Signatory)<br/>
                              </td>
                             <td>{(camDetails?.cam_lender !=='' && camDetails?.cam_lender ==='Vivriti') ? "For cKers Finance Pvt Ltd on Behalf of Vivriti Capital Limited" : "For cKers Finance Pvt Ltd" }<br/>
                             {camDetails?.dmemo_maker_by}
                             </td>
                             <td>
                             (Acknowledgement of Dealer)<br/>
                             </td>
                             
                         </tr>
                     </table>   
             </div>
          </div>
 
       </div>
       <br/> 
           {(isReadyToModify && (userRoleType === 'Credit' || userRoleType === 'Credit Operations' || userRoleType === 'Superadmin')) ? (
             <>
 
              { savedSanctionDetailsInfo?.action_status_do  === '1' ? ( <> 
                 { ( !enableUpdatePdfDetails) && (
                 <button className='btn btn-warning text-white float-right- mb-2' onClick={handleDownloadPdf}>Generate PDF</button>
                 )}
              </> ) :
              (
                 <>
                 { ( !enableUpdatePdfDetails) ? (
                 <button type="button" className="btn btn-primary text-white mb-2" onClick={handleToggleUpdateDetails} >Update Details</button>
                 ) : (
                     <>
                     <button type="button" className="btn btn-primary text-white mb-2" onClick={handleToggleSaveDetails} >Save Details</button>
 
                     &nbsp;<button type="button" className="btn btn-danger text-white mb-2" onClick={handleToggleUpdateDetails} >Cancel</button>
                     </>
                 )}
 
                 { ( !enableUpdatePdfDetails) && (
                 <button className='btn btn-warning text-white float-right mb-2' onClick={handleDownloadPdf}>Generate PDF</button>
                 )}
 
                 </>
             )}
 
                 { (savedSanctionDetailsInfo?.action_status_do  > 0  && savedSanctionDetailsInfo?.action_status_do  < 3) && ( 
                     <> 
                      <button className="btn btn-danger float-right mb-2" type="button" onClick={() => btnOpenRejectData('3')} > Reversal Request </button>
                     </>
                  )} 
                 </>
 
             ) : (
                 <></>
             )} 
 
 
                 { ( isReadyToModify && (userRoleType === 'Credit Head-' || userRoleType === 'Superadmin' || userRoleType === 'Credit Operations') && refDoNo !=='' ) ? (
                   
                   <>
                     <div className='form-group text-end mb-2'>
                         <button className="btn btn-success" type="button"  onClick={() => btnOpenRejectData('1')}> Approve</button>&nbsp;
                        
                         <button className="btn btn-danger" type="button" onClick={() => btnOpenRejectData('2')} > Reject </button>
                     </div> 


                     { userRoleType === 'Credit Operations' && isReadyToModify && showSanctionNote !== "" && (sanctionApproveLatestStatus === '1' )  && sanctionApproveAndSendMailLatestStatus < 1 && (
                      <div className='form-group text-end mb-2'>
                          <button className="btn btn-success" type="button"  onClick={() => btnOpenRejectData('1','1')} title="Send mail to Customer, Sales Person, CAM email and Logged-in user"> Send Mail </button>&nbsp; 
                  </div> 
                    )}
 
                    
                     </>
                   
                 ) : (
                   <>
                  
                    { isReadyToModify && showSanctionNote !== "" && (sanctionApproveLatestStatus === '1' )  && sanctionApproveAndSendMailLatestStatus < 1 && (
                      <div className='form-group text-end mb-2'>
                          <button className="btn btn-success" type="button"  onClick={() => btnOpenRejectData('1','1')} title="Send mail to Customer, Sales Person, CAM email and Logged-in user"> Send Mail </button>&nbsp; 
                  </div> 
                    )}
                   </>
               )}
 
  
             { showSanctionNote !== ""   && (
                 <div className={sanctionApproveLatestStatus=== '0' ? "text-end text-primary" : ( sanctionApproveLatestStatus=== '1' ? "text-end text-success" : "text-end text-red" )}>{showSanctionNote}</div>
                 )}  
         
        
     </div>
  </>
 )
 } 

</div>
</div>
</div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Lead Document</h4>
                    </div>

                    <div className='modal-body'>
                        <div className='row mb-2 pb-1'>
                            <div className='col-1'>&nbsp;</div>
                            <div className='col-10 ps-0'>{viewModalInfo.note}</div>
                        </div>
                    </div>
                </div>
            </Modal>


            <Modal
                open={openAmt}
                onClose={handleCloseAmt}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">What is the proposed EMI amount?</h4>
                        <Button onClick={handleCloseAmt} color="primary" className=' btn'>
                            <i className="bi bi-x">&nbsp;</i>
                        </Button>
                    </div>
                    
                    <div className='modal-body'>
                        <div>
                            <form onSubmit={handleSubmit(handleFormSubmit)} encType="multipart/form-data">
                                <div className="row mx-0">
                                    <div className="col-md-6 px-0">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>EMI Amount <a style={{ color: "red" }}>*</a></span>
                                                <input type='number' id='emi_amount' name='emi_amount'
                                                    className='form-control' {...register('emi_amount')}
                                                    onChange={handleAmtChange}/>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>Debit Date <a style={{ color: "red" }}>*</a></span>
                                                <input type='date' id='debit_date' name='debit_date'
                                                    className='form-control' {...register('debit_date')}
                                                    onChange={handleDebitDateChange}/>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 px-0">
                                        <div className="form-group mb-0">
                                            <button className="btn btn-primary mt-2">
                                                Submit
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* UPI REGISTRATION MODAL START */}
            <Modal open={openUPIAmt} onClose={handleCloseUPIAmt} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <div className='modal-custom rounded'>
                <div className='modal-head'>
                <h4 id="modal-title">UPI Amount </h4>
                <Button onClick={handleCloseUPIAmt} color="primary" className='btn'>
                    <i className="bi bi-x"> &nbsp;</i>
                </Button>
                </div>

                <div className='modal-body'>
                <form onSubmit={handleSubmit(handleUPIFormSubmit)} encType="multipart/form-data">
                    <div className="row mx-0">
                    
                    <div className="col-md-6">
                        <div className="form-group">
                        <label htmlFor="itr_file">
                            <span>UPI Amount <a style={{ color: "red" }}>*</a></span>
                            <input type='number' id='emi_amount1' name='emi_amount1' className='form-control'
                            {...register('emi_amount1')} onChange={handleAmtUPIChange}/>
                        </label>
                        </div>
                    </div>

                <div className="col-md-6">
                    <div className="form-group">
                    <label htmlFor="itr_file">
                        <span>Debit Date <a style={{ color: "red" }}>*</a></span>
                        <input type='date' id='upi_debit_date1' name='debit_date1' className='form-control' {...register('debit_date1')} onChange={handleUPIDateChange} />
                    </label>
                    </div>
                </div>

                    <div className="col-md-12">
                        <div className="form-group mb-0">
                        <button className="btn btn-primary mt-2">
                            UPI REGISTRATION NOW
                        </button>
                        </div>
                    </div>
                    </div>
                </form>
                </div>
            </div>
            </Modal>
        {/* UPI REGISTRATION MODAL END */}

             
                  <Modal open={openUploadDoc} onClose={handleCloseUploadDoc} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <div className='modal-custom rounded'>
                          <div className='modal-head'>
                            <h4 id="modal-title"> { /* Enter Notes */ } </h4>
                            <Button onClick={handleCloseUploadDoc} color="primary" className='btn'>
                              <i className="bi bi-x"> &nbsp;</i>
                            </Button>
                          </div>
            
                          <div className='modal-body'>
                             <form onSubmit={handleSubmit(handleDocumentsFormSubmit)} encType="multipart/form-data" ref={formRef}>
                            <div className="row guarantor" id="bank_statement-1">

                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <label htmlFor="document-type">
                                                    <span>Document Type <a style={{ color: "red" }}>*</a></span>
                                                    <select disabled={props.leadStatusFlag === true} id='document_type' className="form-select" name='document_type' {...register('document_type')}> 
                                                        { (uploadBtnAction ==='Agreement') ? ( 
                                                            <>
                                                            <option value='Agreement'>Agreement </option> 
                                                            </>
                                                        ) : ( 
                                                            <>

                                                            { (uploadBtnAction ==='Repayment Details') ? ( 
                                                                    <>
                                                                    <option value='Paper NACH'>Upload Paper NACH</option>
                                                                    <option value='SPDC'>Upload SPDC</option>
                                                                    </>
                                                                ) : ( 
                                                                    <>
                                                                  { (uploadBtnAction ==='Insurance Details') ? ( 
                                                                    <>
                                                                    <option value='Credit Life Insurance'>Credit Life Insurance</option>
                                                                    <option value='Motor Insurance'>Motor Insurance</option>
                                                                    </>
                                                                ) : ( 
                                                                    <>
                                                                   { (uploadBtnAction ==='MSME Certificate') ? ( 
                                                                    <>
                                                                    <option value='Certificate Copy'>Certificate Copy</option>
                                                                    
                                                                    </>
                                                                ) : ( 
                                                                    <>
                                                                 {/* <option value='Pan'>Pan </option>
                                                                   <option value='Signature Sample'>Signature Sample </option> */}

                                                                   {allDocumentTypeData.length > 0 &&
                                                                allDocumentTypeData
                                                                    .filter(option =>
                                                                    option.document_type?.toLowerCase().includes('pan') ||
                                                                    option.document_type?.toLowerCase().includes('signature')
                                                                    )
                                                                    .map(option => (
                                                                    <option key={option.id} value={option.id}>
                                                                        {option.document_type}
                                                                    </option>
                                                                    ))}
                                                                    </> 
                                                                ) } 
                                                                    </> 
                                                                ) } 
                                                                    </> 
                                                                ) } 
                                                            
                                                            </> 
                                                        ) } 
                                                    </select>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="document_file">
                                                    <span>File Upload <a style={{ color: "red" }}>*</a></span>
                                                    <input disabled={props.leadStatusFlag === true} type='file' id='document_file' name='document_file' className='form-control' onChange={handleDocumentFileChange} />
                                                </label>
                                            </div>
                                        </div>

                                        <div className= {uploadBtnAction === 'MSME Certificate' ? "col-md-6" : "col-md-6 d-none"} >
                                            <div className="form-group">
                                                <label htmlFor="registration_no">
                                                    <span>Registration No <a style={{ color: "red" }}>*</a></span>
                                                    <input readOnly={props.leadStatusFlag === true} 
                                                    type='text' 
                                                    id='registration_no' 
                                                    name='registration_no' 
                                                    className='form-control'  
                                                    {...register('registration_no')}
                                                    />
                                                </label>
                                            </div>
                                        </div>

                                        

                                        
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <label htmlFor="document_note">
                                                    <span>Notes <a style={{ color: "red" }}>*</a></span>
                                                    <textarea readOnly={props.leadStatusFlag === true}
                                                        id='document_note'
                                                        className='form-control'
                                                        placeholder="Type Something" {...register('document_note')}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                        </div>

                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group mb-0">
                                                <button disabled={props.leadStatusFlag === true} className="btn btn-primary">Submit</button>
                                            </div>
                                        </div>
                                        </div>
                            </form>
                          </div>
                        </div>
                      </Modal>
                    


                     {/* Reject REGISTRATION MODAL START */}
                        <Modal open={openRejectAmt} onClose={handleCloseRejectAmt} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                            <div className='modal-custom rounded'>
                                <div className='modal-head'>
                                <h4 id="modal-title">Enter Notes </h4>
                                <Button onClick={handleCloseRejectAmt} color="primary" className='btn'>
                                    <i className="bi bi-x"> &nbsp;</i>
                                </Button>
                                </div>
                
                                <div className='modal-body'>
                                <form onSubmit={handleSubmit(handleRejectFormSubmit)} encType="multipart/form-data">
                                    <div className="row mx-0">
                                    
                                    <div className="col-md-6">
                                        <div className="form-group">
                                        <label htmlFor="itr_file">
                                            <span>Notes <a style={{ color: "red" }}>*</a></span> 
                                            < textarea
                                                id='notes'
                                                name='notes'
                                                className='form-control'
                                                {...register('notes')}
                                                    onChange={handleAmtRejectChange}
                                                
                                            />
                </label>
                                        </div>
                                    </div>
                
                                
                
                                    <div className="col-md-12">
                                        <div className="form-group mb-0">
                                        <button className="btn btn-primary mt-2">
                                            Save
                                        </button>
                                        </div>
                                    </div>
                                    </div>
                                </form>
                                </div>
                            </div>
                            </Modal>
                        {/* Reject REGISTRATION MODAL END */}

           <Modal
                open={viewDetailsOpen}
                onClose={handleViewDetailsClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Details</h4>
                    </div>

                    <div className='modal-body'>
                        <div className='row mb-2 pb-1'>
                            <div className='col-1'>&nbsp;</div>
                            
                            <div className="col-10 ps-0">
                                {viewDetailsModalInfo ? (
                                    (() => {
                                    const { result } = viewDetailsModalInfo;
                                    return (
                                        <div>
                                            <h4>Udyam Details</h4>
                                            {result?.enterprise_name && <div><strong>Enterprise Name:</strong> {result.enterprise_name}</div>}
                                            {result?.organisation_type && <div><strong>Organisation Type:</strong> {result.organisation_type}</div>}
                                            {result?.service_type && <div><strong>Service Type:</strong> {result.service_type}</div>}
                                            {result?.gender && <div><strong>Gender:</strong> {result.gender}</div>}
                                            {result?.social_category && <div><strong>Social Category:</strong> {result.social_category}</div>}
                                            {result?.date_of_incorporation && <div><strong>Date of Incorporation:</strong> {result.date_of_incorporation}</div>}
                                            {result?.date_of_commencement && <div><strong>Date of Commencement:</strong> {result.date_of_commencement}</div>}
                                            {result?.email && <div><strong>Email:</strong> {result.email}</div>}
                                            {result?.mobile && <div><strong>Mobile:</strong> {result.mobile}</div>}

                                            {result?.address && (
                                                <>
                                                 <br/><h4>Address</h4> <br/>
                                                {result.address.flat_no && <div><strong>Flat No:</strong> {result.address.flat_no}</div>}
                                                {result.address.building && <div><strong>Building:</strong> {result.address.building}</div>}
                                                {result.address.village && <div><strong>Village:</strong> {result.address.village}</div>}
                                                {result.address.district && <div><strong>District:</strong> {result.address.district}</div>}
                                                {result.address.city && <div><strong>City:</strong> {result.address.city}</div>}
                                                {result.address.state && <div><strong>State:</strong> {result.address.state}</div>}
                                                {result.address.pin && <div><strong>PIN:</strong> {result.address.pin}</div>}
                                                </>
                                            )}

                                            {Array.isArray(result?.enterprise_type) && result.enterprise_type.length > 0 && (
                                                <>
                                                 <br/><h4>Enterprise Type</h4> <br/>
                                                {result.enterprise_type.map((e, index) => (
                                                    <div key={index}>
                                                    {e.classification_year && <div><strong>Classification Year:</strong> {e.classification_year}</div>}
                                                    {e.enterprise_type && <div><strong>Enterprise Type:</strong> {e.enterprise_type}</div>}
                                                    {e.classification_date && <div><strong>Classification Date:</strong> {e.classification_date}</div>}
                                                    </div>
                                                ))}
                                                </>
                                            )}

                                            {Array.isArray(result?.nic_code) && result.nic_code.length > 0 && (
                                                <>
                                                 <br/><h4>NIC Code</h4> <br/>
                                                {result.nic_code.map((n, index) => (
                                                    <div key={index}>
                                                    {n.nic_2_digit && <div><strong>NIC 2 Digit:</strong> {n.nic_2_digit}</div>}
                                                    {n.nic_4_digit && <div><strong>NIC 4 Digit:</strong> {n.nic_4_digit}</div>}
                                                    {n.nic_5_digit && <div><strong>NIC 5 Digit:</strong> {n.nic_5_digit}</div>}
                                                    {n.activity && <div><strong>Activity:</strong> {n.activity}</div>}
                                                    {n.date && <div><strong>Date:</strong> {n.date}</div>}
                                                    </div>
                                                ))}
                                                </>
                                            )}

                                            <br/>
                                            <h4>Other Info</h4> <br/>
                                            {result?.date_of_udyam_registeration && <div><strong>Date of Udyam Registration:</strong> {result.date_of_udyam_registeration}</div>}
                                            {result?.dic && <div><strong>DIC:</strong> {result.dic}</div>}
                                            {result?.["msme-dfo"] && <div><strong>MSME DFO:</strong> {result["msme-dfo"]}</div>}
                                            </div>
                                        
                                    );
                                    })()
                                ) : (
                                    <p>No details available</p>
                                )}
                                </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                    open={viewAllDetailsOpen}
                    onClose={handleViewDetailsClose}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                >
                    <div className='modal-custom rounded'>
                        <div className='modal-head'>
                            <h4 id="modal-title">Details</h4>
                        </div> 
                        <div className='modal-body'>
                            <div className='row mb-2 pb-1'>
                                <div className='col-1'>&nbsp;</div> 
                                <div className="col-10 ps-0"> 
                                    {viewDetailsModalInfo ? (
                                        (() => {
                                        const { result } = viewDetailsModalInfo;
                                        return (
                                            <div>
                                                <h4> Details</h4> 
                                                    <RenderObject data={viewDetailsModalInfo} />
                                                
                                            </div>
                                        );
                                        })()
                                    ) : (
                                        <p>No details available</p>
                                    )}  
                                    </div>
                            </div>
                        </div>
                    </div>
                </Modal>
        </>
    );
}


function mapStateToProps(state) {
    return {
        usersData: state.usersData,
        getUserModuleData: state.getUserModuleData,
        getUploadLeadDocument: state.getUploadLeadDocument,
        masterDocumentTypeData: state.masterDocumentTypeData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(userActions.default, leadActions.default), dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DeliveryOrder);
